// Seasonal tree-type delivery start dates (Norway Spruce / Fraser Fir / Noble Fir) —
// always resolves to the upcoming Nov/Dec, so these never need manual year updates.
// month is 1-indexed (11 = November, 12 = December).
function seasonalStartDate(month, day) {
  var now = new Date();
  var year = now.getFullYear();
  var candidate = new Date(year, month - 1, day);
  if (now > candidate) {
    year += 1;
  }
  var mm = month < 10 ? '0' + month : String(month);
  var dd = day < 10 ? '0' + day : String(day);
  return { mmddyyyy: mm + '/' + dd + '/' + year, year: year };
}

function ordinalSuffix(day) {
  if (day % 10 === 1 && day !== 11) return 'st';
  if (day % 10 === 2 && day !== 12) return 'nd';
  if (day % 10 === 3 && day !== 13) return 'rd';
  return 'th';
}

function seasonalAvailableNoticeText(month, day) {
  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var d = seasonalStartDate(month, day);
  return 'Available from ' + day + ordinalSuffix(day) + ' ' + monthNames[month - 1] + ' ' + d.year;
}

// code start - disallow to purchase collection
//var request = new XMLHttpRequest();
//request.open("GET", "/cart/clear.js");
//request.send();
//location.href = 'https://www.pinesandneedles.com/pages/removal-booking';//open it when required for booking removals
//location.href = 'https://www.pinesandneedles.com';
// code end
//start - allow delvery and collection booking
   $.getJSON('/cart.js', function(cart)
   {
     var txntype = cart['attributes'].txntype;
     if(txntype == "collection"){
     var request = new XMLHttpRequest();
     request.open("GET", "/cart/clear.js");
     request.send();
     location.href = 'https://www.pinesandneedles.com/pages/removal-booking';//open it when required for booking removals
    }
  });
//end- allow delivery and collection booking
$(document).ready(function() {
   $('.discount-txt').hide();
  // Verify cart for paypal checkout
    $(document).on('click', '[data-open-modal-id]', function() {
        var id = $(this).attr('data-open-modal-id');
        $('#' + id).trigger('openmodal').trigger('hideTooltip');
    });

    $('#deliveryModal').on('hidden.bs.modal', function() {
        $("#jq-datepicker").datepicker('destroy');
    });

    $('#deliveryModal').on('shown.bs.modal', function() {

    });


    $(document).on('click', '.left-name', function() {
        var windowWidth = window.innerWidth;
        //if(windowWidth > 767) {
        $(this).trigger('openmodal');
        //}

        if ($(this).closest('#divDeliveryServices').length) {
            window.scrollDiv = '#idcollectionsheading';

        } else if ($(this).closest('#divCollectionServices').length) {
            window.scrollDiv = false;

        }
    });

    $(document).on('openmodal', '.left-name', function() {
        var code = $(this).attr("data-code");
        var serviceType = $(this).attr("data-service");

        // Get service details for selected code
        $.ajax({
            type: "GET",
            url: '/apps/pines/service-code-details.php?code=' + code,
            cache: false,
            dataType: "json",
            beforeSend: function() {
                // do something before the request such as show a loading image
            },
            error: function(err) {
                // handle errors
            },
            success: function(data) {
                var iconText = {};
                iconText['team_in_kilts'] = 'Teams in Kilts';
                iconText['text_tracking'] = 'SMS & Tracking';
                iconText['select_date'] = 'Select Date';
                iconText['timeslot'] = 'Time slot';
                iconText['bring_it_in'] = 'Bring It In';
                iconText['installation'] = 'Installation';
                iconText['install_lights'] = 'Install Lights';
                iconText['decoration_service'] = 'Decoration Service';
                iconText['full_recycling'] = 'Full Recycling';
                iconText['tree_undressed'] = 'Tree Undressed';
                iconText['decoration_packaging'] = 'Decoration Packaging';
                iconText['cleaning_up'] = 'Cleaning Up';
                iconText['courier_dropoff'] = 'Courier Dropoff';
                iconText['weekday_delivery'] = 'Weekday Delivery';
                iconText['saturday_delivery'] = 'Saturday Delivery';


                $('#serviceTitle').html(data.details.title);

                var optFlag = data.details.optFlag;

                var iconsDiv = '';
                $.each(data.images, function(z, val) {
                    iconsDiv += '<div class="item"><img src="' + val + '" alt="' + z + '" /><h4>' + iconText[z] + '</h4></div>';
                });

                $('.divIconsRow').html('<div id="service-carousel">' + iconsDiv + '</div>');

                $('#productCode').val(code);
                $('#serviceType').val(serviceType);

                $('#deliveryModal').modal('show');

                //alert(data.details.start_date);
                //alert(data.details.end_date);

                /*if ($('#isGreenery').val() != 0 && optFlag == 'D') {
                    data.details.start_date = '11/25/2025';
                }*/
                
                if ($('#isSpruce').val() != 0 && optFlag == 'D') {
                    data.details.start_date = seasonalStartDate(12, 5).mmddyyyy;
                }
                if ($('#isFraser').val() != 0 && optFlag == 'D') {
                    data.details.start_date = seasonalStartDate(11, 23).mmddyyyy;
                }
                if ($('#isNobleFir').val() != 0 && optFlag == 'D') {
                    data.details.start_date = seasonalStartDate(11, 23).mmddyyyy;
                }


                var dateFirmate = function(date) {
                    date = date.split('/');
                    return date[2] + ',' + date[0] + ',' + date[1];
                };
                var dateFirmate2 = function(date) {
                    date = date.split(',');
                    return date[1] + '/' + date[2] + '/' + date[0];
                };

                var fDate = dateFirmate(data.details.start_date);

                var sDate = [];

                $("#jq-datepicker").datepicker({
                    minDate: data.details.start_date,
                    maxDate: data.details.end_date,
                    beforeShowDay: function(date) {
                      let _dd = date.getFullYear() + "," + (parseInt(date.getMonth()) + 1) + "," + date.getDate();
                      //let _dd2 = (parseInt(date.getMonth()) + 1) + "" + date.getDate().toString().padStart(2, "0") + "" + date.getFullYear();
                      let month = (date.getMonth()) + 1;
                      let _dd2 = month.toString().padStart(2, "0") + "" + date.getDate().toString().padStart(2, "0") + "" + date.getFullYear();
                      let _timeslots = data.timeslots;
                      let weekdays = data.details.weekdays ? data.details.weekdays.split(",").map(item=> Number(item)) : [];
                      let day = date.getDay();
                      let activeRanges = data.details.activeRanges || [];

                      let dateIsActive;
                      if (activeRanges.length) {
                        let d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                        dateIsActive = activeRanges.some(function(range) {
                          return d >= new Date(range[0]) && d <= new Date(range[1]);
                        });
                      } else {
                        dateIsActive = !!_timeslots[_dd2];
                      }

                      if(dateIsActive) {
                        if(weekdays.length) {
                          if(weekdays.includes(day)) {
                        sDate.push(_dd);
                        return [true, ''];
                          }
                          else {
                            return [false, ''];
                          }
                        }
                        else {
                          sDate.push(_dd);
                          return [true, ''];
                        }
                      }
                      else {
                        return [false, ''];
                      }

                      /*if (data.details.weekdays != '' && data.details.weekdays != null) {
                          if (data.details.weekdays.includes(date.getDay()) !== false) {
                              sDate.push(_dd);
                            //console.log(`date`, date);
                              return [true, ''];
                          } else {
                              return [false, ''];
                          }
                      } else {
                          sDate.push(_dd);
                        //console.log(`date`, date);
                          return [true, ''];
                      }*/
                    },
                    onSelect: function(dateText, inst) {
                        var selDate = dateText.replace(/\//g, '');

                        $('#dayTimeslots').html('');

                        $.each(data.timeslots, function(index, value) {
                            if (index == selDate) {
                                $.each(value, function(index1, value1) {
                                    var arr = value1.split('!@#');

                                    if (arr[1] != 0) {
                                        //if(index1 === 0) {
                                        //$('#dayTimeslots').append('<label><input type="radio" checked="checked" name="timeslot" id="timeslot" value="'+arr[0]+'"><span>'+arr[0]+'</span><span class="checkmark"></span></label>');
                                        //} else {
                                        $('#dayTimeslots').append('<label><input type="radio" name="timeslot" id="timeslot" value="' + arr[0] + '"><span>' + arr[0] + '</span><span class="checkmark"></span></label>');
                                        //}
                                    } else {
                                        $('#dayTimeslots').append('<div class="sold-out-div">' + arr[0] + '<span> (Sold Out)</span></div>');
                                    }
                                });

                                $('#dayTimeslots input:eq(0)').prop('checked', true);
                            }
                        });
                    }
                });




                for (var ind = 0; ind < sDate.length; ind++) {
                    if (new Date(sDate[ind]) >= new Date(fDate)) {

                        $('#jq-datepicker').datepicker("setDate", new Date(sDate[ind]));

                        break;
                    }
                }

                setTimeout(function() {
                    $('#jq-datepicker .ui-datepicker-current-day').click();
                }, 100);



                $('#dayTimeslots').html('');

                /*var i=1;
                  $.each(data.timeslots, function( index, value ) {
                    if(i==1) {
                      $.each(value, function( index1, value1) {
                        	var arr = value1.split('!@#');
                            //console.log(index1);
                        	if(arr[1] != 0) {
                              if(index1 === 0) {
                                $('#dayTimeslots').append('<label><input type="radio" checked="checked" name="timeslot" id="timeslot" value="'+arr[0]+'"><span>'+arr[0]+'</span><span class="checkmark"></span></label>');
                              } else {
                                $('#dayTimeslots').append('<label><input type="radio" name="timeslot" id="timeslot" value="'+arr[0]+'"><span>'+arr[0]+'</span><span class="checkmark"></span></label>');
                              }
                            } else {
                              $('#dayTimeslots').append('<div style="margin: 10px 20px;display: inline-block;color: #F00;">'+arr[0]+'<span> (Sold Out)</span></div>');
                            }
                      });
                    }
                    i = i+1;
                });*/


                var tempDescription = data.details.description;
                var description = tempDescription.replace("&amp;pound;", "£");

                description = description.split("- ");

                var liDesc = '';

                var descSr = 0;
                $.each(description, function(key, value) {
                    if (key === 0 && description.length > 2) {
                        liDesc += '<div class="first-description clearfix">';
                    }

                    if (key === 3) {
                      liDesc += '</div><div class="second-description clearfix" style="display:none">';
                    }

                    if (value != '') {
                        liDesc += '<div class="col-xs-12"><div class="service-in-check">' + value + '</div></div>';
                    }

                    if (description.length > 2 && key + 1 === description.length) {
                        liDesc += '</div><div class="col-xs-12"><a data-first-text="See More" data-second-text="Hide" class="description-show-more" href="#">See More</a></div>';
                    }

                });

                if (liDesc == '' && description != '') {
                    liDesc = this.description;
                }


                if (liDesc != '') {
                    $('#divOtherServices').css('display', 'block');
                    $('#divDescRow').html(liDesc);
                } else {
                    $('#divOtherServices').css('display', 'none');
                    $('#divDescRow').html('');
                }


                $("#service-carousel").owlCarousel({
                    itemsCustom: [
                        [320, 1],
                        [360, 2],
                        [450, 2],
                        [600, 2],
                        [700, 3],
                        [768, 3],
                        [1000, 4],
                        [1200, 5],
                        [1400, 5],
                        [1600, 5]
                    ],
                    autoPlay: false,
                    stopOnHover: false,

                    lazyLoad: false,
                    lazyFollow: true,
                    lazyEffect: "fade",
                    pagination: false,

                    // Navigation
                    navigation: true,
                    navigationText: ['<i class="arrow left"></i>', '<i class="arrow right"></i>'],
                    rewindNav: true,
                    scrollPerPage: false,

                });



            } // end success
        }); // end ajax

    });
  
    $('#chkInstalled').click(function() {
        /*if($('#chkInstalled').is(':checked') == true) {
          $('#chkTimeslot').prop('checked', false);
        } */

        if ($('#postal').val() == '') {
            $('#cartMsgDivNew').css('display', 'block');
            $('#cartMsgDivNew').addClass('cartMsgDivNew');
            $('#cartMsgDivNew').html('Please enter valid postal code');
            return false;
        } else {
            $('#cartMsgDivNew').css('display', 'none');
            $('#cartMsgDivNew').html('');
        }

        var chkInstalled = $('#chkInstalled').is(':checked');
        var chkTimeslot = $('#chkTimeslot').is(':checked');

        var dataString = 'postal=' + $('#postal').val() + '&treeSize=' + $('#cartTreeCode').val() + '&cartOtherCode=' + $('#cartOtherCode').val() + '&chkInstalled=' + chkInstalled + '&chkTimeslot=' + chkTimeslot + '&flag=delivery';
        deliveryOptions(dataString, 'delivery');
    });
  
    $('#chkTimeslot').click(function() {
      /*if($('#chkTimeslot').is(':checked') == true) {
        $('#chkInstalled').prop('checked', false);
      } */


      if ($('#postal').val() == '') {
          $('#cartMsgDivNew').css('display', 'block');
          $('#cartMsgDivNew').addClass('cartMsgDivNew');
          $('body').addClass('cartMsgDivShow');
          $('#cartMsgDivNew').html('Please fill in the required shipping information');
          return false;
      } else {
          $('#cartMsgDivNew').css('display', 'none');
          $('#cartMsgDivNew').html('');
          $('#cartMsgDivNew').removeClass('cartMsgDivNew');
          $('body').removeClass('cartMsgDivShow');
      }

      var chkInstalled = $('#chkInstalled').is(':checked');
      var chkTimeslot = $('#chkTimeslot').is(':checked');

      var dataString = 'postal=' + $('#postal').val() + '&treeSize=' + $('#cartTreeCode').val() + '&cartOtherCode=' + $('#cartOtherCode').val() + '&chkInstalled=' + chkInstalled + '&chkTimeslot=' + chkTimeslot + '&flag=delivery';
      deliveryOptions(dataString, 'delivery');
  });


  $("#chkInJanuary").click(function() {
      if ($('#chkInJanuary').is(':checked') == true) {
          $('#chkBeforeJanuary').prop('checked', false);
      }


      if ($('#postal').val() == '') {
          $('#cartMsgDivNew').css('display', 'block');
          $('#cartMsgDivNew').addClass('cartMsgDivNew');
          $('#cartMsgDivNew').html('Please fill in the required shipping information');
          return false;
      } else {
          $('#cartMsgDivNew').css('display', 'none');
          $('#cartMsgDivNew').html('');
          $('#cartMsgDivNew').removeClass('cartMsgDivNew');
      }

      var chkInJanuary = $('#chkInJanuary').is(':checked');
      var chkBeforeJanuary = $('#chkBeforeJanuary').is(':checked');

      var dataString = 'postal=' + $('#postal').val() + '&treeSize=' + $('#cartTreeCode').val() + '&chkInJanuary=' + chkInJanuary + '&chkBeforeJanuary=' + chkBeforeJanuary + '&flag=collection';
      deliveryOptions(dataString, 'collection');
  });

  $("#chkBeforeJanuary").click(function() {
      if ($('#chkBeforeJanuary').is(':checked') == true) {
          $('#chkInJanuary').prop('checked', false);
      }


      if ($('#postal').val() == '') {
          $('#cartMsgDivNew').css('display', 'block');
          $('#cartMsgDivNew').addClass('cartMsgDivNew');
          $('#cartMsgDivNew').html('Please fill in the required shipping information');
          return false;
      } else {
          $('#cartMsgDivNew').css('display', 'none');
          $('#cartMsgDivNew').html('');
          $('#cartMsgDivNew').removeClass('cartMsgDivNew');
      }


      var chkInJanuary = $('#chkInJanuary').is(':checked');
      var chkBeforeJanuary = $('#chkBeforeJanuary').is(':checked');

      var dataString = 'postal=' + $('#postal').val() + '&treeSize=' + $('#cartTreeCode').val() + '&chkInJanuary=' + chkInJanuary + '&chkBeforeJanuary=' + chkBeforeJanuary + '&flag=collection';
      deliveryOptions(dataString, 'collection');
  });


  $('#aReviewCartBack').click(function() {
      //$('.make-it-deactive').removeClass('make-it-deactive');
      //$('.panel-group-wrapper').addClass('panel-group-deactive');

      $('.checkout-steps-1').addClass('active');
      $('.checkout-steps-2').addClass('active');
      $('.checkout-steps-3').removeClass('active');
      $('body').removeClass('final-step');

      if (window.innerWidth < 991) {
          $('.checkout-steps-1').removeClass('active');
          $("html, body").animate({
              scrollTop: 0
          }, 600);
      }

      if ($("#postal").is(':visible')) {
          $('#postal').focus();
      }
  });

  $(".backToDeliveryOptions").click(function() {
      $('.cart-step-1').addClass('shoMobile');
      $('.cart-step-2').removeClass('shoMobile');

      if ($("#postal").is(':visible')) {
          $('#postal').focus();
      }
  });

  $(".continue-contact-information").click(function() {
    verifyDeliveryDateTimeslot2(function(message) {
      if(message) {
        showMessage(message);
        
      } else {
        window.location.href = '/checkout?step=contact_information';
        
      }
    }, false, this);
  });
              
  $(".step__footer__continue-btn").on('click', function(e, submit) {
      if ($(this).data("trekkie-id") == 'complete_order_button') {

          var cookieEnabled = navigator.cookieEnabled;
          if (cookieEnabled == false) {
              logCookieErrors();
              alert('Your basket has expired, please reload the page and check the basket before proceeding');
              return false;
          }

          if (!submit) {
              //verifyCartForServicesOnOrder(function(){
              verifyDeliveryDateTimeslot(function() {
                  $('[data-trekkie-id="complete_order_button"]:visible').trigger('click', [true]);
              });
              // });

              return false;
          }
      }
  });

  $('input[name="chkGDPR"]').click(function() {
      if ($('input[name="chkGDPR"]').is(':checked') && $('#fullname').val() != '' && $('#email').val() != '') {

          var isGDPR = 1;

          var dataStringLead = 'name=' + $('#fullname').val() + '&email=' + $('#email').val() + '&phone=' + $('#phone').val() + '&postcode=' + $('#postal').val() + '&isGDPR=' + isGDPR;
          //Add lead to klaviyo
          $.ajax({
              url: "/apps/pines/cart-lead.php",
              type: "POST",
              data: dataStringLead,
              cache: false,
              processData: false,
              success: function(data) {

              }
          });
      }
  });
    
  $(".paypal-button").click(function() {

      //Validate billing information page
      if ($('#fullname').val() == '' || $('#phone').val() == '' || $('#email').val() == '' || $('#address1').val() == '' || $('#city').val() == '' || $('#postal').val() == '') {
          $('#cartMsgDivNew').css('display', 'block');
          $('#cartMsgDivNew').addClass('cartMsgDivNew');
          $('#cartMsgDivNew').html('Please fill in the required shipping information');
          return false;
      }

      $.ajax({
          type: "GET",
          url: '/cart.json',
          cache: false,
          success: function(data) {
              var services = 0;
              var trees = 0;

              $.each(data.items, function(i) {
                  if (this.product_type == 'Delivery Services') {
                      services = services + 1;
                  } else if (this.product_type == 'Nordmann Fir' || this.product_type == 'Norway Spruce' || this.product_type == 'Pot Grown Fraser Fir' || this.product_type == 'Fraser Fir' || this.product_type == 'Noble Fir Christmas Trees' || this.product_type == 'Value Range Christmas Trees') {
                      trees = parseInt(this.quantity) + 1;
                  }
              });

              //atleast 1 service should be selected
              if (services == 0) {
                  $('#cartMsgDivNew').css('display', 'block');
                  $('#cartMsgDivNew').addClass('cartMsgDivNew');
                  $('#cartMsgDivNew').html('Please select Delivery/Installation service');
                  $("html, body").animate({
                      scrollTop: $('#tblServices').offset().top
                  }, "slow");
                  return false;
              }

              //Should not have more than 5 trees
              if (trees > 5) {
                  $('#cartMsgDivNew').css('display', 'block');
                  $('#cartMsgDivNew').addClass('cartMsgDivNew');
                  $('#cartMsgDivNew').html("Sorry but you can't have more than 5 trees in cart");
                  return false;
              }

              $('#cartMsgDivNew').css('display', 'none');
              $('#cartMsgDivNew').removeClass('cartMsgDivNew');
              //validate the cart

              return true;
          }
      });
  });
    
    $("#btnGetDeliveryOptions").click(function(e) {
        $('#triggerClick').val('1');
        $('.discount-txt').hide();
        showDescountText();
    });
    
    $("#btnGetDeliveryOptions").click(function(e) {
      $('#triggerClick').val('1');

      var postal = $('#postal').val();
      //var dataString = 'postal=' + $('#postal').val() + '&treeSize=' + $('#cartTreeCode').val() + '&cartOtherCode=' + $('#cartOtherCode').val() + '&flag=delivery';
      //var dataString = 'postal=' + $('#postal').val() + '&treeSize=' + $('#cartTreeCode').val() + '&flag=collection' + '&chkInJanuary=true';

      if(postal) {
        
        var chkInstalled = $('#chkInstalled').is(':checked');
		var chkTimeslot = $('#chkTimeslot').is(':checked');
        var cartOtherCode = $('#cartOtherCode').val();
		var dataString = 'postal=' + $('#postal').val() + '&treeSize=' + $('#cartTreeCode').val() + '&cartOtherCode=' + cartOtherCode + '&chkInstalled=' + chkInstalled + '&chkTimeslot=' + chkTimeslot + '&flag=delivery';
        
        //var dataString = 'postal=' + $('#postal').val()+'&treeSize='+$('#cartTreeCode').val()+'&cartOtherCode='+$('#cartOtherCode').val()+'&flag=delivery';
      	deliveryOptions(dataString,'delivery');
      
      	$('#chkInJanuary').prop('checked', false);
      
      	var dataString = 'postal=' + $('#postal').val()+'&treeSize='+$('#cartTreeCode').val()+'&flag=collection'+'&chkInJanuary=false';
      	deliveryOptions(dataString,'collection');
        
        showDescountText();

      } else {
        $('#postCodeErrorId').addClass('clsErrorPostCode');
        $('#postCodeErrorId').css('display', 'block');
        $('#chkInstalled').prop('checked', false);
        $('#chkTimeslot').prop('checked', false);
        $('#chkInJanuary').prop('checked', false);
        $('#chkBeforeJanuary').prop('checked', false);

        $('#divDeliveryServices').removeClass('show-continue-btn');
        $('#divDeliveryServices').html('Fill in shipping postcode to see available services');
        $('#divCollectionServices').html('Fill in shipping postcode to see available services');
        return false;

      }
    });
    
    $('body').on('click', '.description-show-more', function() {
      var firstText = $(this).attr('data-first-text');
      var secondText = $(this).attr('data-second-text');

      if ($('.second-description').is(':visible')) {
          $('.second-description').slideUp();
          $(this).text(firstText);
          $(this).removeClass("description-hide-more");

      } else {
          $('.second-description').slideDown();
          $(this).text(secondText);
          $(this).addClass("description-hide-more");
      }
  });
    
    $('#continueToReview').click(function() {
        $('.cart-step-1').removeClass('shoMobile');
      	$('.cart-step-2').addClass('shoMobile');

        $("html, body").animate({
          scrollTop: 0
        }, 300);
    });
    
    $('.cart-table').on('click', '.panel-title', function() {
        var href = $(this).find('a').attr('href');

        if (href && href !== '#') {
            window.location.href = href;
        }


    });
    
    $('#postal').keypress(function(event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '13') {
            $('#btnGetDeliveryOptions').trigger('click');
        }
    });
    
    $(document).on("click", '.qty-adjust', function(event) {

        var variantId = $(this).attr("data-id");
        if (variantId == '') {
            return false;
        }

        var quantity = $('#updates_' + variantId).val();
        var flag = $(this).attr("data-flag");


        if (flag == 'minus') {
            quantity = parseInt(quantity) - 1;
        } else if (flag == 'plus') {
            quantity = parseInt(quantity) + 1;
        } else {
            return false;
        }

        $('#cartLoading, #cartLoading2').html('<img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/ajax-loader.gif?v=97146236628943878521783230625">');

        if (quantity == 0) {
            removeItem(variantId);
        } else {
            $.ajax({
                type: "GET",
                url: '/cart/change?id=' + variantId + '&quantity=' + quantity,
                cache: false,
                success: function(data) {
                    $(this).val(quantity);
                    renderCart();
                }
            });
        }
    });
    
  $('.clsContinue').click(function() {
    location.href = "/collections/nondrop-indoor-nordmann-fir-real-christmas-trees";
  });
  
  $('body').on("keyup", "#couponCode", function(e) {
    var keyCode = e.keyCode;
    var coupon = $('#couponCode').val();
    
    if(coupon && coupon.trim().length) {
      $('.addcouponCodeBtn').prop('disabled', false);
    } else {
      $('.addcouponCodeBtn').prop('disabled', true);
      $('.couponError').text('');
    }
    
    if(keyCode === 13) {
      $('.addcouponCodeBtn').trigger('click');
    }
  });
  
  $('body').on("click", ".addcouponCodeBtn", function(e) {
    let couponCode = $('#couponCode').val();
    $('#cartLoading, #cartLoading2').html(loader);
    
    couponValidation(couponCode, function(message) {
      if(message) {
        $('#cartLoading, #cartLoading2').html('');
      } else {
        addCouponNew(couponCode, ()=> {
          console.log(`aa`, couponCode);
          afterRenderMainCart();
          couponHtml();
        });
        //renderCart(false, false, $('#couponCode').val());
      }
      
      $('#couponCode').val('');
    });
  });
  
  $('body').on("click", ".removeCoupon", function(e) {
    removeCoupon();
  });

  /*checkCoupon(function() { 
    renderCart('fisrtLoad', function(data) {
      verifyCartForServices(data, function() {
        $('.checkout-body-cart-div').removeClass('checkout-loader');
      });
    });
  });*/
  
  /*checkCoupon(function(attr, coupon, message) {
    
  });*/

  renderCart('fisrtLoad', function(data) {
    $('.checkout-body-cart-div').removeClass('checkout-loader');
  });
});
let oldAllCoupon;
let getAllCoupon = function() {
  return new Promise((resolve, reject)=> {
    if(oldAllCoupon) {
      resolve(oldAllCoupon);
    }
    else {
      $.ajax({
        type: 'GET',
        url: '/apps/pan/free_coupon_codes.php',
        dataType: "json",
        contentType: 'application/json',
        cache: false,
        success: function(data) {
          oldAllCoupon = Object.keys(data).reduce(function(result, key) {
               result[key.toLowerCase()] = data[key];
               return result;
          }, {});
          resolve(oldAllCoupon);
        }
      });
    }
  });
};
let addItem = function(id, quantity) {
  return new Promise((resolve, reject)=> {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {id, quantity},
        dataType: 'json',
        success: function(data) {
          resolve(data);
        }
      });
  });
};
let cartDataAsync = function() {
  return new Promise((resolve, reject)=> {
    $.ajax({
      type: "GET",
      contentType: 'application/json',
      url: '/cart.json',
      cache: false,
      success: function(data) {
        resolve(data);
      }
    });
  });
};
let addFreeProduct = function(coupon) {
  return new Promise(async (resolve, reject)=> {
    let allCoupon = await getAllCoupon();
    let free_item_id = allCoupon[coupon.trim().toLowerCase()];
    let cart = await cartDataAsync();
    let freeItem = null;
    if(free_item_id) {
      let item = cart.items.find((item) => (item.id === free_item_id));
      if(item) {
        freeItem = item;
      }
      else {
        freeItem = await addItem(free_item_id, 1);
        cart = await cartDataAsync();
      }
    }
    
    resolve([freeItem, cart]);
});
};

var renderCart = function(code, callback, coupon = false) {
  adjustMultipleTreeDeliveryCharges(function(){       
    adjustMultipleTreeCollectionCharges(function(){        
      renderMainCart(code, callback, coupon);
    });
  });
};
  
var renderMainCart = function(code, callback, coupon) {
  $.ajax({
    type: "GET",
    url: '/cart.json',
    cache: false,
    success: function(data) {
      verifyCartForServices(data, code, function(hasService, isCartPage) {
          

        afterRenderMainCart(code);
        
          
          

        couponHtml();
        
        callback && callback(data);
        
        if(isCartPage && code === 'fisrtLoad') {
          $('.cart-table-cell.cart-step-3').addClass('disabled');
          $('.cart-table-cell.cart-step-1').addClass('shoMobile');

        } else if(code === 'fisrtLoad') {
          $('.cart-table-cell.cart-step-1, .cart-table-cell.cart-step-2').addClass('disabled');
          $('.cart-table-cell.cart-step-3').addClass('shoMobile');

        }
        
        
        
      });
      
    }
  });
};

var afterRenderMainCart = async function(c) {
  var code = c ? c : '';
  let data = await cartDataAsync();
  let allCoupon = await getAllCoupon();
  let freeItem;
  
  if (data.attributes.postal != '' && data.attributes.postal != null && data.attributes.postal != undefined) {
    $('#postal').val(data.attributes.postal);
    $('#deliveryPostal').val(data.attributes.postal);
  }

  $('#checkout_shipping_address_zip').val($('#postal').val());

  if (data.items.length == 0) {
    location.href = '/cart';
    return false;
  }
  

  //console.log(data);                         
  //Check if extra tree product available
  var extraDeliveryText = '';
  var extraDeliveryCost = '';
  var extraDeliveryId = '';
  var extraCollectionText = '';
  var extraCollectionCost = '';
  var extraCollectionId = '';
  var isDeliveryService = 'no';

  $.each(data.items, function(i) {
    if (this.product_type == 'Extra Delivery Services') {
      extraDeliveryText = 'Delivery charges for ' + this.quantity + ' extra tree(s)';

      extraDeliveryCost = (this.line_price / 100);
      extraDeliveryCost = extraDeliveryCost.toFixed(2);

      extraDeliveryId = this.id;

    } else if (this.product_type == 'Extra Collection Services') {
      extraCollectionText = 'Collection charges for ' + this.quantity + ' extra tree(s)';

      extraCollectionCost = (this.line_price / 100);
      extraCollectionCost = extraCollectionCost.toFixed(2);

      extraCollectionId = this.id;
    } else if (this.product_type == 'Collection Services' || this.product_type == 'Delivery Services') {
      isDeliveryService = 'yes';
    }
    if(Object.values(allCoupon).includes(this.id)) {
      freeItem = this;
    }
  });


  $('#radioDiv' + code).addClass('collections-checked');

  var totalDue = (data.original_total_price / 100);
  var totalDue = totalDue.toFixed(2);
  var outputText = '';

  // First render Nordmann products and Norway
  var cartTreeCode = '';
  var cartOtherCode = '';
  var cartDeliveryCode = '';
  var cartTreeCodeNordmann = '';
  var cartTreeCodeNorway = '';
  var cartTreeCodePotted = '';
  var cartTreeCodeFraser = '';

  var lightProducts = 0;
  var lightServices = $('#lightServiceCodes').val();
  var totalCartTrees = 0;

  var norwayTree = 0;
  var greenery = 0;
  var fraserTree = 0;
  var nobleFirTree = 0;
  
  outputText += '<table>' +
    '<tr>' +
    '<td>Order Total</td>' +
    '<td>£' + totalDue + '</td>' +
    '</tr>';

  $.each(data.items, function(i) {
    if (this.product_type != 'Extra Delivery Services' && this.product_type != 'Extra Collection Services') {
      var availableNotice = '';
      var delieryOn = '';
      var rowId = this.id;
      var isFree = couponList.find(function(val) {
        return val.id === rowId;
      });
      
      //console.log('isFree: ' + isFree);
      //console.log(val.id);
      //console.log(rowId);

      if (this.product_type == 'Collection Services' || this.product_type == 'Delivery Services') {
        var title = this.product_title;
        // alert(title);

        cartDeliveryCode = this.sku;

        if (this.properties != null) {
          if ($.isArray(this.properties)) {
            $.each(this.properties, function(k, j) {
              var name = j.name;
              var nameVal = j.value;
              if (name.includes("Date") !== false) {
                delieryOn += nameVal + ', ';
              } else if (name.includes("Timeslot") !== false) {
                delieryOn += nameVal;
              }
            });
          } else {
            $.each(this.properties, function(k, j) {
              if (k.includes("Date") !== false) {
                delieryOn += j + ', ';
              } else if (k.includes("Timeslot") !== false) {
                delieryOn += j;
              }
            });
          }
        }



        if (this.product_type == 'Delivery Services' && extraDeliveryText != '') {
          if (lightServices.includes(this.sku) !== false) {
            var qtyAdjust = '<div class="js-qty"><span style="font-size:12px;padding-top:2px;">Delivery On: ' + delieryOn + '</span><br><p style="margin-top:8px;">' + extraDeliveryText + '</p><div class="clear"></div><span class="lightNoticeAlt"></span>';
          } else {
            var qtyAdjust = '<div class="js-qty"><span style="font-size:12px;padding-top:2px;">Delivery On: ' + delieryOn + '</span><br><p style="margin-top:8px;">' + extraDeliveryText + '</p>';
          }
        } else if (this.product_type == 'Collection Services' && extraCollectionText != '') {
          if (lightServices.includes(this.sku) !== false) {
            var qtyAdjust = '<div class="js-qty"><span style="font-size:12px;padding-top:2px;">Collection On: ' + delieryOn + '</span><br><p style="margin-top:8px;">' + extraCollectionText + '</p><div class="clear"></div><span class="lightNoticeAlt"></span>';
          } else {
            var qtyAdjust = '<div class="js-qty"><span style="font-size:12px;padding-top:2px;">Collection On: ' + delieryOn + '</span><br><p style="margin-top:8px;">' + extraCollectionText + '</p>';
          }
        } else {
          // Delivery or collection
          if (this.product_type == 'Delivery Services') {
            if (lightServices.includes(this.sku) !== false) {
              var qtyAdjust = '<div class="js-qty"><span style="font-size:12px;padding-top:2px;">Delivery On: ' + delieryOn + '</span><br><div class="clear"></div><span class="lightNoticeAlt"></span>';
            } else {
              var qtyAdjust = '<div class="js-qty"><span style="font-size:12px;padding-top:2px;">Delivery On: ' + delieryOn + '</span><br>';
            }
          } else if (this.product_type == 'Collection Services') {
            if (lightServices.includes(this.sku) !== false) {
              var qtyAdjust = '<div class="js-qty"><span style="font-size:12px;padding-top:2px;">Collection On: ' + delieryOn + '</span><br><div class="clear"></div><span class="lightNoticeAlt"></span>';
            } else {
              var qtyAdjust = '<div class="js-qty"><span style="font-size:12px;padding-top:2px;">Collection On: ' + delieryOn + '</span><br>';
            }
          }
        }

      } else {
        if (this.product_type == 'Lights') {
          lightProducts = parseInt(lightProducts) + 1;
        }
      if (this.product_type == 'Norway Spruce') {
          norwayTree = 1;
          availableNotice = seasonalAvailableNoticeText(12, 5);
}
      /*else if (this.product_type == 'Greenery') {
          greenery = 1;
          availableNotice = ''; // was "Available from 25th November 2025"
      }*/
      if (this.product_type == 'Fraser Fir') {
          fraserTree = 1;
          availableNotice = seasonalAvailableNoticeText(11, 23);
      }
          if (this.product_type == 'Noble Fir Christmas Trees') {
          nobleFirTree = 1;
          availableNotice = seasonalAvailableNoticeText(11, 23);
      }

		
        var readonly = isFree ? 'readonly': '';
        var disabled = isFree ? 'disabled': '';
        var title = this.product_title;
        var qtyAdjust = '<div class="js-qty">' +
            '<button type="button" ' + disabled + ' class="qty-adjust" data-flag="minus" data-id="' + this.id + '">' +
            '<span class="fallback-text" aria-hidden="true">−</span>' +
            '</button>' +
            '<input type="text" ' + readonly + ' style="width:30px;" class="js-qty__num" value="' + this.quantity + '" min="1" data-id="' + this.id + '" aria-label="quantity" pattern="[0-9]*" name="updates[]" id="updates_' + this.id + '">' +
            '<button type="button" ' + disabled + ' class="qty-adjust" data-flag="plus" data-id="' + this.id + '">' +
            '<span class="fallback-text" aria-hidden="true">+</span>' +
            '</button>';
      }


      // For Garland and Decoration services related items
      if (this.sku == 'DS08' || this.sku == 'DS09' || this.sku == 'DS10' || this.sku == 'DS11' || this.sku == 'DS12' || this.sku == 'GAR1DC' || this.sku == 'GAR2DC' || this.sku == 'GAR2PL' || this.sku == 'GAR2FLW') {
        cartOtherCode = this.sku;
      }

      if (this.product_type == 'Nordmann Fir' || this.product_type == 'Norway Spruce' || this.product_type == 'Pot Grown Fraser Fir' || this.product_type == 'Fraser Fir' || this.product_type == 'Noble Fir Christmas Trees' || this.product_type == 'Value Range Christmas Trees') {
        if (this.sku > cartTreeCode) {
          cartTreeCode = this.sku;
        }

        totalCartTrees = totalCartTrees + this.quantity;

        if (this.product_type == 'Nordmann Fir') {
          if (this.sku > cartTreeCodeNordmann) {
            cartTreeCodeNordmann = this.sku;
          }
        } else if (this.product_type == 'Norway Spruce') {
          if (this.sku > cartTreeCodeNorway) {
            cartTreeCodeNorway = this.sku;
          }
        } else if (this.product_type == 'Pot Grown Fraser Fir') {
          if (this.sku > cartTreeCodePotted) {
            cartTreeCodePotted = this.sku;
          }
        } else if (this.product_type == 'Fraser Fir') {
          if (this.sku > cartTreeCodeFraser) {
            cartTreeCodeFraser = this.sku;
          }
        }else if (this.product_type == 'Noble Fir Christmas Trees') {
          if (this.sku > cartTreeCodeFraser) {
            cartTreeCodeFraser = this.sku;
          }
        }else if (this.product_type == 'Value Range Christmas Trees') {
          if (this.sku > cartTreeCodeFraser) {
            cartTreeCodeFraser = this.sku;
          }
        }
      }

      var image = '';
      if (this.image != '' && this.image != null) {
        image = '<a class="checkout-pr-icon" href="' + this.url + '"><img src="' + this.image + '" alt="' + title + '" width="50" height="50"></a>';
      } else {
        image = '<a class="checkout-pr-icon" href="' + this.url + '"><img src="//cdn.shopify.com/s/assets/no-image-160-1cfae84eca4ba66892099dcd26e604f5801fdadb3693bc9977f476aa160931ac_compact.gif" alt="' + title + '" width="50" height="50"></a>';
      }

      outputText += '<tr>' +
        '<td>' + image + '<div class="checkout-pr-text"><span>' + title + '</span>';



      var availableNoticeHtml = availableNotice ? '<div style="font-size:12px;color:#56534d;margin-top:4px;">' + availableNotice + '</div>' : '';
      outputText += qtyAdjust + '</div></div><div class="clearfix"></div>' + availableNoticeHtml + '</td>';

      var linePrice = (this.line_price / 100);
      var linePrice = linePrice.toFixed(2);
      
      
      if (this.product_type == 'Delivery Services' && extraDeliveryCost != '') {
        outputText += '<td width="90px">£' + linePrice +
          '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ',' + extraDeliveryId + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a>' +
          '<p>' + (parseFloat(extraDeliveryCost) === 0 ? 'Free' : '£' + extraDeliveryCost) + '</p></td>' +
          '</tr>';
      } else if (this.product_type == 'Collection Services' && extraCollectionCost != '') {
        outputText += '<td width="90px">£' + linePrice +
          '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ',' + extraCollectionId + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a>' +
          '<p style="margin-top:8px;">' + (parseFloat(extraCollectionCost) === 0 ? 'Free' : '£' + extraCollectionCost) + '</p></td>' +
          '</tr>';
      } else {
        if (this.product_type == 'Mini Tree' && this.quantity == 1) {
          outputText += '<td width="90px"><span id="spnMiniTree">£' + linePrice + '</span>' +
            '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
            '</tr>';
        } else if (this.product_type == 'FRCSET' && this.quantity == 1) {
          outputText += '<td width="90px"><span id="spnFestiveTree">£' + linePrice +
            '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
            '</tr>';
        } else if (this.id == 17448051212353 && this.quantity == 1) {
          outputText += '<td width="90px"><span id="spnLightTree">£' + linePrice + '</span>' +
            '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
            '</tr>';
        } /*else if (this.id == 12754531975233 && this.quantity == 1) {
          outputText += '<td width="90px"><span id="spnEntranceTree">£' + linePrice + '</span>' +
            '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
            '</tr>';
        }*/ else if (this.id == 31064970199105 && this.quantity == 1) {
          outputText += '<td width="90px"><span id="spnHolly">£' + linePrice + '</span>' +
            '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
            '</tr>';
        } else if (this.id == 27900488384577 && this.quantity == 1) {
          outputText += '<td width="90px"><span id="spnMoment">£' + linePrice + '</span>' +
            '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
            '</tr>';
        } else if (this.id == 12780085248065 && this.quantity == 1) {
          outputText += '<td width="90px"><span id="spnLightUp">£' + linePrice + '</span>' +
            '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
            '</tr>';
        } else if(freeItem && freeItem.id === this.id) {
          let finalPrice = linePrice === "0.00" ? "Free" : ('£' + linePrice);
          outputText += '<td width="90px"><span id="freeItem">' + finalPrice + '</span>' +
            '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
            '</tr>';
        } else {
          
          if(isFree) {
            outputText += '<td width="90px"><span class="freeText" data-price="£' + linePrice + '">FREE</span>' +
              '<a href="javascript:void(0);" class="remove-cart-ico removeCoupon"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
              '</tr>';
            
          } else {
            outputText += '<td width="90px">£' + linePrice +
              '<a href="javascript:void(0);" class="remove-cart-ico" onclick="removeItem(' + this.id + ')"><img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/trash-icon-2.png?v=71598975362447532861783230625" alt="Delete"></a></td>' +
              '</tr>';
          }
          
        }
      }
    }
  });

  $('#isSpruce').val(norwayTree);
  $('#isGreenery').val(greenery);
  $('#isFraser').val(fraserTree);
  $('#isNobleFir').val(nobleFirTree);

  if (cartTreeCodeNordmann != '') {
    cartTreeCode = cartTreeCodeNordmann;
  } else if (cartTreeCodeNorway != '') {
    cartTreeCode = cartTreeCodeNorway;
  } else if (cartTreeCodeFraser != '') {
    // Fraser Fir and Noble Fir Christmas Trees share this bucket (both feed
    // cartTreeCodeFraser above) - Nordmann > Norway > {Noble, Fraser} > Potted.
    cartTreeCode = cartTreeCodeFraser;
  } else if (cartTreeCodePotted != '') {
    cartTreeCode = cartTreeCodePotted;
  }

  

  var vat = (data.items_subtotal_price / 100) * 0.1666;
  var vat = vat.toFixed(2);

  var netPrice = (data.items_subtotal_price / 100) - vat;
  var netPrice = netPrice.toFixed(2);

  outputText += '<tr>' +
    '<td>NET:</td>' +
    '<td>£' + netPrice + '</td>' +
    '</tr>' +
    '<tr>' +
    '<td>VAT:</td>' +
    '<td>£' + vat + '</td>' +
    '</tr>' +
    '<tr>' +
    '<td>Total due:</td>' +
    '<td>£' + totalDue + '</td>' +
    '</tr>';

  outputText += '</table>';
  
  outputText += '<input type="hidden" id="cartTreeCode" name="cartTreeCode" value="' + cartTreeCode + '">';
  outputText += '<input type="hidden" id="cartOtherCode" name="cartOtherCode" value="' + cartOtherCode + '">';
  outputText += '<input type="hidden" id="cartDeliveryCode" name="cartDeliveryCode" value="' + cartDeliveryCode + '">';
  
  $('#divReviewCart').html(outputText);
  $('#cartLoading, #cartLoading2').html('');


  if (lightProducts < 1) {
    $('.lightNoticeAlt').addClass('lightNotice');
    $('.lightNotice').html('Dec service does not include any products');
  }

  $('#isDeliveryService').val(isDeliveryService);
  $('#totalCartTrees').val(totalCartTrees);

  //alert($('.tag__text reduction-code__text').text());
  

  var discountCode = $('.reduction-code__text').text();

  if (discountCode.includes("FREEMINI2019")) {
    //$('#spnMiniTree').text('Free');
  } else if (discountCode.includes("FREEMINI")) {
    $('#spnMiniTree').text('Free');
  } else if (discountCode.includes('FESTIVE10')) {
    $('#spnFestiveTree').text('Free');
  } else if (discountCode.includes('FESTIVE18')) {
    $('#spnMiniTree').text('Free');
  } else if (discountCode.includes('FESTIVE19')) {
    $('#spnMiniTree').text('Free');
  } else if (discountCode.includes('ENTRANCE')) {
    $('#spnEntranceTree').text('Free');
  } else if (discountCode.includes('LIGHTITUP')) {
    $('#spnLightTree').text('Free');
  } else if (discountCode.includes('FRESH')) {
    $('#spnFestiveTree').text('Free');
  } else if (discountCode.includes('WREATH19')) {
    $('#spnEntranceTree').text('Free');
  } else if (discountCode.includes('HOLLY')) {
    $('#spnHolly').text('Free');
  } else if (discountCode.includes('MOMENT')) {
    $('#spnMoment').text('Free');
  } else if (discountCode.includes('MOMENT20')) {
    $('#spnMoment').text('Free');
  }else if (discountCode.includes('LIGHTUP19')) {
    $('#spnLightUp').text('Free');
  }else if (discountCode.includes('WREATH20')) {
    $('#spnLightUp').text('Free');
  }else if (discountCode.includes('GLAM20')) {
    $('#spnLightUp').text('Free');
  } else if (discountCode.includes('COSY')) {
    $('#spnCosy').text('Free');
  }
  /*else if (discountCode.includes('FREESWAG')) {
    $('#spnFreeswag').text('Free');
  }*/
  else if (discountCode.includes('MINIGIFT')) {
    $('#spnMiniGift').text('Free');
  }else if (discountCode.includes('MINILONDON')) {
    $('#spnMiniGift').text('Free');
  }else if (discountCode.includes('LONDONGIFT')) {
    $('#spnMiniGift').text('Free');
  }else if (discountCode.includes('HAPPY') || discountCode.includes('SMILE') || discountCode.includes('XMAS') || discountCode.includes('GIFT') || discountCode.includes('FESTIVE')) {
    $('#spnMiniGift').text('Free');
  }else if (discountCode.includes('HOLLYHALO')) {
    $('#spnHollyWreath').text('Free');
  }else if (discountCode.includes('NOBLEHALO')) {
    $('#spnNobleWreath').text('Free');
  }else if (discountCode.includes('SERVING23')) {
    $('#spnServing23').text('Free');
  }else if (discountCode.includes('EXTRABRIGHT')) {
    $('#spnExtrabright').text('Free');
  }

  

  if ($('#postal').val() != '' && !$('#divDeliveryServices').hasClass('show-continue-btn')) {
    $("#btnGetDeliveryOptions").trigger('click');
  }
  //verifyCart(isDeliveryService,totalCartTrees);       

  setTimeout(function() {
    if (window.innerWidth < 991 && window.scrollDiv) {

      $("html, body").animate({
        scrollTop: $(window.scrollDiv).offset().top - 10
      }, 600);
    }
  }, 500);


  /*Shipping address fields prepopulate based on cart attributes*/
  if ($('#checkout_email').val() == '') {
    $('#checkout_email').val(data.attributes.email);
  }


  if (data.attributes.fullname != '' && data.attributes.fullname != undefined) {
    var str = data.attributes.fullname;
    var ret = str.split(" ");

    var fname = ret[0];
    var lname = '';

    if (ret[1] != null && ret[1] != undefined) {
      var lname = ret[1];
    }

    if ($('#checkout_shipping_address_first_name').val() == '') {
      $('#checkout_shipping_address_first_name').val(fname);
    }
    if ($('#checkout_shipping_address_last_name').val() == '') {
      $('#checkout_shipping_address_last_name').val(lname);
    }
  }

  if ($('#checkout_shipping_address_phone').val() == '') {
    $('#checkout_shipping_address_phone').val(data.attributes.phone);
  }

  if ($('#checkout_shipping_address_city').val() == '') {
    $('#checkout_shipping_address_city').val(data.attributes.city);
  }
  
  
  
  
};

var psmPostalCode = function(tempPostal, flag, cartItems) {

    if (cartItems == '') {
        var pageUrl = '/apps/pines/psm-postal-codes.php?code=' + tempPostal + '&flag=' + flag;
    } else {
        var pageUrl = '/apps/pines/psm-postal-codes.php?code=' + tempPostal + '&flag=' + flag + '&cartItems=' + cartItems;
    }

    $.ajax({
        type: "GET",
        url: pageUrl,
        cache: false,
        dataType: "json",
        beforeSend: function() {},
        error: function(err) {},
        success: function(data) {}
    });
};

var chkCartItems = function(callback) {
    var cartItems = '';
    $.ajax({
        type: "GET",
        url: '/cart.json',
        cache: false,
        success: function(data) {

            $.each(data.items, function(i) {
                cartItems = cartItems + ',' + this.sku;
            });

            callback(cartItems);
        }
    });
};

var deliveryOptions = function(dataString, flag) {
    // validate uk postcode
    var tempPostal = $('#postal').val();
    var tempPostalTemp = tempPostal.replace(/\s+/g, '');

    $.ajax({
        type: "GET",
        url: 'https://api.postcodes.io/postcodes/' + tempPostalTemp + '/validate',
        cache: false,
        dataType: "json",
        success: function(data) {
            if (data.result == true) {
                getDeliveryOptions(dataString, flag, tempPostal);
            } else {
                if(tempPostalTemp == "w111ba"){
                  getDeliveryOptions(dataString, flag, tempPostal);
                }else{
                  $('#postCodeErrorId').css('display', 'block');
                  $('#postCodeErrorId').addClass('clsErrorPostCode');
                  $('#chkInstalled').prop('checked', false);
                  $('#chkTimeslot').prop('checked', false);
                  $('#chkInJanuary').prop('checked', false);
                  $('#chkBeforeJanuary').prop('checked', false);
  
                  $('#divDeliveryServices').removeClass('show-continue-btn');
                  $('#divDeliveryServices').html('Fill in shipping postcode to see available services');
                  $('#divCollectionServices').html('Fill in shipping postcode to see available services');
  
                  //Postal code
                  if ($('#triggerClick').val() != '' && flag != 'collection') {
                      psmPostalCode(tempPostal, 1, '');
                  }
                  return false; 
              }
                
            }
        }
    });
};

var getDeliveryOptions = function(dataString, flag, tempPostal) {
    $('#postCodeErrorId').removeClass('clsErrorPostCode');
    $('#postCodeErrorId').css('display', 'none');

    $('#cartMsgDivNew').css('display', 'none');
    $('#cartMsgDivNew').html('');
    $('#cartMsgDivNew').removeClass('cartMsgDivNew');

    if (flag == 'both' || flag == 'delivery') {
        $('#divDeliveryServices').html('Filtering services please wait....');
    }

    if (flag == 'both' || flag == 'collection') {
        $('#divCollectionServices').html('Filtering services please wait....');
    }
  
  


    $.ajax({
        type: "GET",
        url: '/apps/pines/delivery-options-final.php',
        cache: false,
        dataType: "json",
        data: dataString,
        beforeSend: function() {
            // do something before the request such as show a loading image
        },
        error: function(err) {
            // handle errors
        },
        success: function(data) {

            var lightServices = '';
          
            if (flag == 'both' || flag == 'delivery') {
                $('#divDeliveryServices').html('');

                if (data.delivery.length > 0) {

                    // For nation wide services show message to user
                    if (data.is_nationwide == 1 && $('#chkInstalled').is(':checked') == true) {
                        $('#divDeliveryServices').append("<div style='padding:2px 0 10px 0;color:#ff6347;'>We don't offer installation in your postcode, but we do offer the following options..</div>");
                    }

                    if ($('#triggerClick').val() != '' && flag != 'collection') {
                        psmPostalCode(tempPostal, 3, '');
                    }


                    $.each(data.delivery, function(i) {
                        var timeslots = 'No time slots';
                        if (this.timeslots != '') {
                            var tempSlots = this.timeslots;
                            var indSlots = tempSlots.split(',');

                            var timeslots = '';

                            for (kl = 0; kl < indSlots.length; kl++) {
                                timeslots += '<span class="timeslot-cls">' + indSlots[kl] + '</span>';
                            }
                        }

                        var popular = '';
                        //removed most popular button as suggested by Tom on 15-11-2024
                        /*if (this.is_popular == 'Y') {
                            var popular = '<span class="popular">Most Popular</span>';
                        }*/

                        var iconsDiv = '<p><span>Service Includes: </span></p>';

                        //alert(this.icons.length);


                        //if(this.icons.length >0) {

                        $.each(this.icons, function(z, val) {
                            iconsDiv += '<span class="tag-br">' + val + '</span>';
                        });
                        //}  


                        // Description as bullets
                        var description = this.description;
                        description = description.split("- ");

                        var liDesc = '';
                        $.each(description, function(key, value) {
                            if (value != '') {
                                liDesc += '<li>' + value + '</li>';
                            }
                        });

                        if (liDesc == '') {
                            liDesc = this.description;
                        }
                      
                        $('#divDeliveryServices').append('<div class="delivery-installation-row">' +
                            '<input name="bd" type="radio" value="' + this.code + '">' +
                            '<div class="left-name-wrapper">' +
                            '<div class="left-name" data-code="' + this.code + '" data-service="delivery" id="radioDiv' + this.code + '">' + this.title + popular + '</div>' +
                            '</div>' +
                            '<div class="right-price">£' + this.cost + '</div>' +
                            '</div>');
                    });

                    $('#divDeliveryServices').addClass('show-continue-btn');
                } else {

                    if ($('#triggerClick').val() != '' && flag != 'collection') {
                        chkCartItems(function(cartItems) {
                            psmPostalCode(tempPostal, 2, cartItems);
                        });
                    }

                    $('#divDeliveryServices').append('Delivery services not available for this postal code.');
                    $('#divDeliveryServices').removeClass('show-continue-btn');
                }

                $('input[type=radio][name=optDelivery]').change(function() {
                    addServiceToCart($(this).val(), 'D');
                });
            }


            if (flag == 'both' || flag == 'collection') {

                $('#divCollectionServices').html('');

                var removalDisplayOrder = ["CRNBA", "CRNST", "CRNSA", "CRNPT", "CRUBA", "CRWBA", "CRUSA", "CRWSA", "CRUSW", "CRWSW", "CRUPA", "CRWPA", "CRUPW", "CRWPW", "CRNSX", "CRNPX", "CRNBAG", "CRNSG", "CRNPG", "CRUSG", "CRWSG", "CRUPG", "CRWPG"];
                data.collections.sort(function(a, b) {
                    var aIndex = removalDisplayOrder.indexOf(a.code);
                    var bIndex = removalDisplayOrder.indexOf(b.code);
                    if (aIndex === -1) aIndex = removalDisplayOrder.length;
                    if (bIndex === -1) bIndex = removalDisplayOrder.length;
                    return aIndex - bIndex;
                });

                if (data.collections.length > 0) {

                    $.each(data.collections, function(i) {
                        var timeslots = 'No time slots';
                        if (this.timeslots != '') {
                            var timeslots = this.timeslots;
                        }

                        var popular = '';

                        /*if (this.is_popular == 'Y') {
                            var popular = '<font color=red><b>*</b></font>';
                        }*/

                        var iconsDiv = '';

                        //if(this.icons.length >0) {
                        var isLight = 0;
                        $.each(this.icons, function(z, val) {
                            if (z == 'install_lights') {
                                isLight = parseInt(isLight) + 1;
                            }

                            iconsDiv += '<span class="tag-br">' + val + '</span>';
                        });
                        //}  

                        // alert(this.code +'->'+popular);
                        if (isLight > 0) {
                            lightServices += this.code + ',';
                        }

                        //alert(this.code +'->'+this.popular);

                        // Description as bullets
                        var description = this.description;
                        // alert(description);
                        description = description.split("- ");

                        var liDesc = '';
                        $.each(description, function(key, value) {
                            if (value != '') {
                                liDesc += '<li>' + value + '</li>';
                            }
                        });

                        if (liDesc == '') {
                            liDesc = this.description;
                        }

                        $('#divCollectionServices').append('<div class="delivery-installation-row">' +
                            '<input name="bd" type="radio"  value="' + this.code + '">' +
                            '<div class="left-name-wrapper">' +
                            '<div class="left-name" data-code="' + this.code + '" data-service="collection" id="radioDiv' + this.code + '">' + this.title + popular + '</div>' +
                            '</div>' +
                            '<div class="right-price">£' + this.cost + '</div>' +
                            '</div>');
                    });
                } else {
                    $('#divCollectionServices').append('Collection services not available for this postal code.');
                }

                $('input[type=radio][name=optCollections]').change(function() {
                    addServiceToCart($(this).val(), 'C');
                });

            }

            // Check if is in cart already
            chkServiceInCart();
        } // end success
    }); // end ajax
};


var chkServiceInCart = function () {
    $.ajax({
        type: "GET",
        url: '/cart.json',
        cache: false,
        success: function(data) {
            $.each(data.items, function(i) {
              $('#radioDiv' + this.sku).addClass('collections-checked');
              if($('#radioDiv' + this.sku).length) {
                $.ajax({
                    type: "GET",
                    url: '/cart/update.js?attributes[postal]=' + $('#postal').val(),
                    cache: false,
                    success: function(data) {}
                });
                $('#deliveryPostal').val($('#postal').val());
              }
            });
        }
    });
};

var addServiceToCart = function() {
    var code = $('#productCode').val();
    var serviceType = $('#serviceType').val();
  var postalCode = $('#postal').val();

    if ($("#jq-datepicker").val() == '' || $("#jq-datepicker").val() == null || $("input[name='timeslot']:checked").val() == '' || $("input[name='timeslot']:checked").val() == undefined) {
        alert('Please make sure you have selected a date and timeslot');
        return false;
    } else {
        $.ajax({
            type: "GET",
            url: '/cart/update.js?attributes[postal]=' + $('#postal').val(),
            cache: false,
            async:false,
            success: function(data) {}
        });

        // Check if any other service is already added to cart. Remove if yes
        $('#cartLoading, #cartLoading2').html('<img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/ajax-loader.gif?v=97146236628943878521783230625">');

        $('#deliveryPostal').val($('#postal').val());

        if (serviceType == 'delivery') {
            var typeToChk = 'Delivery Services';
        } else if (serviceType == 'collection') {
            var typeToChk = 'Collection Services';
        }

        $.ajax({
            type: "GET",
            url: '/cart.json',
            cache: false,
            success: function(data) {
                $('#cartMsgDivNew').css('display', 'none');
                $('#cartMsgDivNew').html('');
                $('#cartMsgDivNew').removeClass('cartMsgDivNew');
                removeItemFromCart2(typeToChk, data.items, function() {
                    addDeliveryServiceMain(code, serviceType);
                });

            }
        });
    }
};

var addDeliveryServiceMain = function(code, serviceType) {
    // Add to cart
    $('#deliveryModal').modal('hide');
    $.ajax({
        type: "GET",
        url: '/products/' + code + '.json',
        cache: false,
        success: function(data) {
            var firstVariant = data.product.variants[0].id;

            if (firstVariant != '') {

                var delShopifyDate = '';

                if ($("#jq-datepicker").val() != '' && $("#jq-datepicker").val() != null) {
                    var delDate = $("#jq-datepicker").val();
                    delDate = delDate.split('/');
                    delShopifyDate = delDate[1] + '/' + delDate[0] + '/' + delDate[2];
                }

                $.post('/cart/add.js', {
                    quantity: 1,
                    id: firstVariant,
                    properties: {
                        'Date : ': delShopifyDate,
                        'Timeslot : ': $("input[name='timeslot']:checked").val(),
                        'Parking : ': $("#parking").val(),
                        'Delivery Entrace : ': $("#deliveryEntrance").val(),
                        'List / Stairs? : ': $("#liftStairs").val(),
                        'Home / Office? : ': $("#homeOffice").val(),
                        'Note : ': $("#serviceNotes").val()
                    }
                }).always(function(error) {
                    //alert('yy');
                    renderCart(code);

                });

            } else {
                alert('Not found variant!!');
            }
        }
    });
};

var removeItem = function(id, extraTreeId, callback) {
  var url = '/cart/update.js?updates[' + id + ']=0';
  
  if(extraTreeId) {
    url += '&updates[' + extraTreeId + ']=0';
  }
  
  $('#cartLoading, #cartLoading2').html(loader);
  
  $.ajax({
    dataType: "json",
     contentType: "application/json; charset=utf-8",
    type: "POST",
    url: url,
    cache: false,
    success: function(data) {
      if(data.items.length === 0) {
        window.location.reload();
      }
      renderCart();
      couponHtml();

      if ($('#postal').val() != '') {
        var dataString = 'postal=' + $('#postal').val() + '&treeSize=' + $('#cartTreeCode').val() + '&cartOtherCode=' + $('#cartOtherCode').val() + '&cartOtherCode=' + $('#cartOtherCode').val() + '&flag=delivery';
        deliveryOptions(dataString, 'delivery');

        $('#chkInJanuary').prop('checked', true);

        var dataString = 'postal=' + $('#postal').val() + '&treeSize=' + $('#cartTreeCode').val() + '&flag=collection' + '&chkInJanuary=true';
        deliveryOptions(dataString, 'collection');
      }
    }
  });
  
    
    
  
    




};

var removeService = function(serviceType) {
    if (serviceType == 'delivery') {
        var typeToChk = 'Delivery Services';
    } else if (serviceType == 'collection') {
        var typeToChk = 'Collection Services';
    }

    $.ajax({
        type: "GET",
        url: '/cart.json',
        cache: false,
        success: function(data) {

            $.each(data.items, function(i) {
                if (typeToChk == this.product_type) {
                    removeItemFromCartAlternate(this.id);
                    $('#radioDiv' + this.sku).removeClass('collections-checked');
                }
            });

        }
    });

    return true;
};

var chkProductInCart = function(productType) {
    $.ajax({
        type: "GET",
        url: '/cart.json',
        cache: false,
        success: function(data) {
            var isInCart = 0;

            $.each(data.items, function(i) {
                if (productType == this.product_type) {
                    isInCart = isInCart + 1;
                }
            });

            callback(isInCart);
        }
    });
};

var removeItemFromCart = function(id, callback) {
  $.ajax({
    type: "GET",
    url: '/cart/change?id=' + id + '&quantity=0',
    cache: false,
    success: function(data) {
      callback && callback();
    }
  });
};

var removeItemFromCart2 = function(typeToChk, items, callback) {
    var loop = 0;
    var applyCallBack = true;

    $.each(items, function(i) {
        loop = i + 1;

        if (typeToChk == this.product_type) {

            var id = this.id;

            applyCallBack = false;

            $.ajax({
                type: "GET",
                url: '/cart/change?id=' + id + '&quantity=0',
                cache: false,
                success: function(data) {
                    if (loop === items.length) {
                        callback();
                    }
                }
            });

            $('#radioDiv' + this.sku).removeClass('collections-checked');
        }

        if (applyCallBack === true && loop === items.length) {
            callback();
        }
    });
};

//Extra delivery chanrges for multiple trees
var adjustMultipleTreeDeliveryCharges = function(callback) {
    $.ajax({
        type: "GET",
        url: '/cart.json',
        cache: false,
        success: function(data) {
          
          if(data.items.length === 0) {
          	return;
          }
          
            var totalTrees = 0;
            var deliverCode = '';
            var collectionCode = '';

            var extraDeliverCode = '';
            var extraCollectionCode = '';

            var extraDeliveryId = '';
            var extraCollectionId = '';

            var currentExtraTreeProducts = 0;
            var orphanServiceIds = [];
            var hasTreeLikeItem = false;
            // Pick Up carts: stands / lights / decorations are only valid alongside a tree
            var pickupCartHasPickupLine = false;
            var pickupAccessoryIds = [];

            $.each(data.items, function(i) {
                if (this.product_type == 'Decorated' || this.product_type == 'Popular Tree') {
                    hasTreeLikeItem = true;
                }
                if (this.product_type == 'Nordmann Fir' || this.product_type == 'Norway Spruce' || this.product_type == 'Pot Grown Fraser Fir' || this.product_type == 'Fraser Fir' || this.product_type == 'Noble Fir Christmas Trees' || this.product_type == 'Value Range Christmas Trees') {
                    totalTrees = totalTrees + this.quantity;
                } else if (this.product_type == 'Delivery Services') {
                    deliverCode = this.sku;
                    if (this.sku !== 'DCPHW' && this.sku !== 'DCPHN' && this.sku !== 'DCPNW') {
                        orphanServiceIds.push(this.id);
                    }
                } else if (this.product_type == 'Extra Delivery Services') {
                    extraDeliverCode = this.sku;
                    extraDeliveryId = this.id;
                    orphanServiceIds.push(this.id);
                }

                if (this.product_type == 'Extra Delivery Services' || this.product_type == 'Extra Collection Services') {
                    currentExtraTreeProducts = currentExtraTreeProducts + this.quantity;
                }

                if (this.product_type == 'Pick Up Services') {
                    pickupCartHasPickupLine = true;
                    pickupAccessoryIds.push(this.id);
                } else if (this.product_type == 'Stands' || this.product_type == 'Lights' || this.product_type == 'Decorations') {
                    pickupAccessoryIds.push(this.id);
                }
            });

            // Last tree removed from a Pick Up cart: drop the pick-up line and any stand / lights /
            // decorations so they can't be collected on their own.
            if (totalTrees == 0 && pickupCartHasPickupLine) {
                orphanServiceIds = orphanServiceIds.concat(pickupAccessoryIds);
            }


            $(".cart-count").text(data.item_count - currentExtraTreeProducts);

            //If extra trees found in cart
            if (totalTrees > 1) {
                var extraTrees = totalTrees - 1;

                //For Delivery services
                if (deliverCode != '' && extraDeliverCode == '') {
                    // If delivery service is available but extra delivery product not added then add extra delivery product
                    addExtraDeliveryProduct(deliverCode + '-extra', extraTrees, function() {
                        callback();
                    });

                } else if (deliverCode != '' && extraDeliverCode != '' && extraDeliverCode == deliverCode + '-EXTRA') {
                    // If delivery service is available , extra delivery product is added and matches with delivery service then update it                             
                    if (extraDeliveryId != '') {
                        $.ajax({
                            type: "GET",
                            url: '/cart/change?id=' + extraDeliveryId + '&quantity=' + extraTrees,
                            cache: false,
                            success: function(data) {
                                callback();
                            }
                        });
                    }
                } else if (deliverCode != '' && extraDeliverCode != '' && extraDeliverCode != deliverCode + '-EXTRA') {
                    // If delivery service is available , extra delivery product is added but not matching with delivery service then remove it and it new one
                    if (extraDeliveryId != '') {
                        removeItemFromCart(extraDeliveryId, function() {
                            callback();
                        });
                    }

                    addExtraDeliveryProduct(deliverCode + '-extra', extraTrees, function() {
                        callback();
                    });
                } else {
                    callback();
                }
            } else if (totalTrees == 0 && !hasTreeLikeItem && orphanServiceIds.length > 0) {
                // Last tree removed: a real delivery service (and its extra line) has nothing to deliver, so drop it.
                // No-tree courier services (DCPHW/DCPHN/DCPNW) are legitimate without a tree and are left alone.
                var pending = orphanServiceIds.length;
                $.each(orphanServiceIds, function(i, id) {
                    removeItemFromCart(id, function() {
                        pending--;
                        if (pending === 0) {
                            $.ajax({
                                type: "GET",
                                url: '/cart.json',
                                cache: false,
                                success: function(d) {
                                    if (d.items.length === 0) {
                                        window.location.reload();
                                    } else {
                                        callback();
                                    }
                                }
                            });
                        }
                    });
                });
            } else {
                if (extraDeliveryId != '') {
                    removeItemFromCart(extraDeliveryId, function() {
                        callback();
                    });
                } else {
                    callback();
                }
            }
        }
    });
};

//Extra collection chanrges for multiple trees
var adjustMultipleTreeCollectionCharges = function(callback) {
    $.ajax({
        type: "GET",
        url: '/cart.json',
        cache: false,
        success: function(data) {

            var totalTrees = 0;
            var deliverCode = '';
            var collectionCode = '';

            var extraDeliverCode = '';
            var extraCollectionCode = '';

            var extraDeliveryId = '';
            var extraCollectionId = '';

            $.each(data.items, function(i) {
                if (this.product_type == 'Nordmann Fir' || this.product_type == 'Norway Spruce' || this.product_type == 'Pot Grown Fraser Fir' || this.product_type == 'Fraser Fir' || this.product_type == 'Noble Fir Christmas Trees' || this.product_type == 'Value Range Christmas Trees') {
                    totalTrees = totalTrees + this.quantity;
                } else if (this.product_type == 'Collection Services') {
                    collectionCode = this.sku;
                } else if (this.product_type == 'Extra Collection Services') {
                    extraCollectionCode = this.sku;
                    extraCollectionId = this.id;
                }
            });


            //If extra trees found in cart
            if (totalTrees > 1) {
                var extraTrees = totalTrees - 1;

                // For collection services
                if (collectionCode != '' && extraCollectionCode == '') {
                    addExtraDeliveryProduct(collectionCode + '-extra', extraTrees, function() {
                        callback();
                    });
                } else if (collectionCode != '' && extraCollectionCode != '' && extraCollectionCode == collectionCode + '-EXTRA') {
                    if (extraCollectionId != '') {
                        $.ajax({
                            type: "GET",
                            url: '/cart/change?id=' + extraCollectionId + '&quantity=' + extraTrees,
                            cache: false,
                            success: function(data) {
                                callback();
                            }
                        });
                    }
                } else if (collectionCode != '' && extraCollectionCode != '' && extraCollectionCode != collectionCode + '-EXTRA') {
                    if (extraCollectionId != '') {
                        removeItemFromCart(extraCollectionId, function() {
                            callback();
                        });
                    }

                    addExtraDeliveryProduct(collectionCode + '-extra', extraTrees, function() {
                        callback();
                    });

                } else {
                    callback();
                }

            } else {
                if (extraCollectionId != '') {
                    removeItemFromCart(extraCollectionId, function() {
                        callback();
                    });
                }
                callback();
            }
        }
    });
};

var addExtraDeliveryProduct = function(code, extraTrees, callback) {
    $.ajax({
        type: "GET",
        url: '/products/' + code + '.json',
        cache: false,
        success: function(data) {
            var firstVariant = data.product.variants[0].id;

            if (firstVariant != '') {
                $.ajax({
                    type: "POST",
                    url: '/cart/add?quantity=' + extraTrees + '&id=' + firstVariant,
                    cache: false,
                    success: function(data) {
                        callback();
                    }
                });

            }
        },
        error: function(data) {
            callback();
        }
    });
};

var showPostalCode = function(position) {

    $.ajax({
        type: "POST",
        url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + position.coords.latitude + ',' + position.coords.longitude + '&sensor=true',
        cache: false,
        dataType: "json",
        beforeSend: function() {
            // do something before the request such as show a loading image
        },
        error: function(err) {
            // handle errors
        },
        success: function(data) {
            var addresses = data.results; // cache results in a local var
            $.each(addresses, function(i) { // iterate through to find a postal code
                if (this.types[0] == "postal_code") { // check that the type is a postal code
                    var postal = this['address_components'][0]['long_name']; // grab postal string
                    if (postal.length > 3) { // is the result is more then 3 letter shorthand use it
                        // do something with your result and then lets break the iteration
                        $('#postal').val(postal);
                        $("#postal").trigger("blur");
                    }
                }
            });
        } // end success
    }); // end ajax
};
  
var hasServices = function(data, code, callback) {
  if (data.token == '') {
    alert('Sorry!! Seems your session has expired. Please try again.');
    location.href = '/collections/nondrop-indoor-nordmann-fir-real-christmas-trees';
    return false;
  }

  var services = 0;
  var actualDeliveryService = 0;
  var trees = 0;
  var productsInCart = 0;
  var url = window.location.href;
  var isCartPage = url.indexOf('cart') !== -1 ? true : false;

  //$('.checkout-body-cart-div').removeClass('checkout-loader');

  $.each(data.items, function(i) {
    if (this.product_type == 'Delivery Services') {
      services = services + 1;

      // Check whether it is actual delivery service means no tree delivery sevice
      if (this.sku != 'DCPHW' && this.sku != 'DCPHN' && this.sku != 'DCPNW') {
        actualDeliveryService = actualDeliveryService + 1;
      }
    } else if (this.product_type == 'Nordmann Fir' || this.product_type == 'Norway Spruce' || this.product_type == 'Pot Grown Fraser Fir' || this.product_type == 'Fraser Fir' || this.product_type == 'Noble Fir Christmas Trees' || this.product_type == 'Value Range Christmas Trees') {
      trees = parseInt(this.quantity) + 1;
    }

    if (this.product_type != 'Delivery Services' && this.product_type != 'Collection Services') {
      productsInCart = productsInCart + 1;
    }
  });

  //atleast 1 service should be selected
  if (services == 0) {

    if ($("#postal").is(':visible')) {
      $('#postal').focus();

    }

	callback && callback(false, isCartPage);
    return false;
  }

  //Should not have more than 5 trees
  if (trees > 5) {
    callback && callback(false, isCartPage);
    return false;
  } else if (trees == 0 && actualDeliveryService > 0) {
    callback && callback(false, isCartPage);
    return false;
  } else if (trees > 0 && actualDeliveryService == 0) {
    callback && callback(false, isCartPage);
    return false;
  } else if (services > 0 && productsInCart == 0) {
    callback && callback(false, isCartPage);
    return false;
  }

  /*$('.checkout-steps-1, checkout-steps-2').removeClass('active');
            $('.checkout-steps-3').addClass('active');
            $('body').addClass('final-step');
            $('#checkout_email').focus();*/
  
  if(locationSearch().discount) {
    callback && callback(true, isCartPage);
    
  } else if(locationSearch().review) {
    callback && callback(true, isCartPage);
    
  } /*else if(isCartPage && code === 'fisrtLoad') {
    debugger;
    location.href="/checkout";
    
  }*/ else {
    callback && callback(true, isCartPage);
    
  }
  
};
  
var verifyCartForServices = function (cart, code, callback) {
  if(cart) {
    hasServices(cart, code, callback);
    
  } else {
    $.ajax({
        type: "GET",
        url: '/cart.json',
        cache: false,
        success: function(data) {
          hasServices(data, code, callback);
        }
    });
    
  }
};
  
var logCookieErrors = function () {
    $.getJSON('/cart.js', function(cart) {
        var token = cart.token;
        var totalPrice = cart.total_price;
        var itemCount = cart.item_count;
        var email = '';

        $.getJSON("http://ipinfo.io", function(data) {
            var userDetails = 'City: ' + data.city + " ,County: " + data.country + " ,IP: " + data.ip + " ,Location: " + data.loc + " ,Organisation: " + data.org + " ,Postal Code: " + data.postal + " ,Region: " + data.region;

            getCartItems(cart.items, function(itemList) {
                var pageUrl = '/apps/pines/log-cookie.php?token=' + token + '&email=' + email + '&totalPrice=' + totalPrice + '&itemCount=' + itemCount + '&itemList=' + itemList + '&userDetails=' + userDetails;

                $.ajax({
                    type: "GET",
                    url: pageUrl,
                    cache: false,
                    dataType: "json",
                    beforeSend: function() {},
                    error: function(err) {},
                    success: function(data) {}
                });
            });
        })

    });
};
  
var getCartItems = function (cartItems, callback) {
    var items = '';

    $.each(cartItems, function(cartdatakey, cartdatavalue) {
        items += cartdatavalue.sku + ',';
    });

    callback(items);
};
  
var verifyDeliveryDateTimeslot = function (callback) {
    $.ajax({
        type: "GET",
        url: '/cart.json',
        cache: false,
        success: function(data) {
            var deliveryServices = 0;
            var collectionServices = 0;
            var dataLength = data.items.length;
            var totalSucess = 0;


            $.each(data.items, function(i) {
                if (this.product_type == 'Delivery Services' || this.product_type == 'Collection Services') {

                    if (this.product_type == 'Delivery Services') {
                        deliveryServices = deliveryServices + 1;
                    } else if (this.product_type == 'Collection Services') {
                        collectionServices = collectionServices + 1;
                    }

                    var serviceCode = this.sku;
                    var cartDate = '';
                    var cartSlot = '';

                    if ($.isArray(this.properties)) {
                        $.each(this.properties, function(k, j) {
                            var name = j.name;
                            var nameVal = j.value;

                            if (name.includes("Date") !== false) {
                                cartDate = nameVal;
                            } else if (name.includes("Timeslot") !== false) {
                                cartSlot = nameVal;
                            }
                        });
                    } else {
                        $.each(this.properties, function(k, j) {
                            if (k.includes("Date") !== false) {
                                cartDate = j;
                            } else if (k.includes("Timeslot") !== false) {
                                cartSlot = j;
                            }
                        });
                    }

					
                    if (cartDate != '' && cartSlot != '') {
                    

                        $.ajax({
                            type: "GET",
                            url: '/apps/pines/verifyDeliveryDetails.php?serviceCode=' + serviceCode + '&cartDate=' + cartDate + '&cartSlot=' + cartSlot + '&productType=' + this.product_type,
                            dataType: "json",
                            cache: false,
                            success: function(data) {
                                if (data.status != 'Success') {
                                    if (window.innerWidth <= 991) {
                                        $('.checkout-steps-2').addClass('active');
                                    } else {
                                        $('.checkout-steps-1, checkout-steps-2').addClass('active');
                                    }

                                    $('.checkout-steps-3').removeClass('active');
                                    $('body').removeClass('final-step');
                                    $('#cartMsgDivNew').css('display', 'block');
                                    $('#cartMsgDivNew').addClass('cartMsgDivNew');
                                    $('#cartMsgDivNew').html(data.content);
                                    $("html, body").animate({
                                        scrollTop: $('#tblServices').offset().top
                                    }, "slow");
                                } else {

                                    totalSucess++;

                                    if (totalSucess === dataLength) {
                                        // Check if cart has atleast 1 delivery service
                                        if (deliveryServices == 0 || deliveryServices > 1) {
                                            if (window.innerWidth <= 991) {
                                                $('.checkout-steps-2').addClass('active');
                                            } else {
                                                $('.checkout-steps-1, checkout-steps-2').addClass('active');
                                            }

                                            $('.checkout-steps-3').removeClass('active');
                                            $('body').removeClass('final-step');
                                            $('#cartMsgDivNew').css('display', 'block');
                                            $('#cartMsgDivNew').addClass('cartMsgDivNew');
                                            $('#cartMsgDivNew').html('Please select Delivery/Installation service');
                                            $("html, body").animate({
                                                scrollTop: $('#tblServices').offset().top
                                            }, "slow");
                                        } else {
                                            callback();
                                        }
                                    }
                                }
                            },
                            error: function(err) {
                                console.log(err);
                            },
                        });
                    } else {
                        if (window.innerWidth <= 991) {
                            $('.checkout-steps-2').addClass('active');
                        } else {
                            $('.checkout-steps-1, checkout-steps-2').addClass('active');
                        }

                        $('.checkout-steps-3').removeClass('active');
                        $('body').removeClass('final-step');
                        $('#cartMsgDivNew').css('display', 'block');
                        $('#cartMsgDivNew').addClass('cartMsgDivNew');
                        $('#cartMsgDivNew').html('Please select delivery date / time');
                        $("html, body").animate({
                            scrollTop: $('#tblServices').offset().top
                        }, "slow");
                    }

                } else {
                    totalSucess++;

                    if (totalSucess === dataLength) {
                        // Check if cart has atleast 1 delivery service
                        if (deliveryServices == 0 || deliveryServices > 1) {
                            if (window.innerWidth <= 991) {
                                $('.checkout-steps-2').addClass('active');
                            } else {
                                $('.checkout-steps-1, checkout-steps-2').addClass('active');
                            }

                            $('.checkout-steps-3').removeClass('active');
                            $('body').removeClass('final-step');
                            $('#cartMsgDivNew').css('display', 'block');
                            $('#cartMsgDivNew').addClass('cartMsgDivNew');
                            $('#cartMsgDivNew').html('Please select Delivery/Installation service');
                            $("html, body").animate({
                                scrollTop: $('#tblServices').offset().top
                            }, "slow");
                        } else {
                            callback();
                        }
                    }
                }

            });

        }
    });

    return true;
};
  
var verifyCartForServicesOnOrder = function () {
    $.ajax({
        type: "GET",
        url: '/cart.json',
        cache: false,
        success: function(data) {
            var services = 0;
            var actualDeliveryService = 0;
            var trees = 0;
            var productsInCart = 0;

            $.each(data.items, function(i) {
                if (this.product_type == 'Delivery Services') {
                    services = services + 1;

                    // Check whether it is actual delivery service means no tree delivery sevice
                    if (this.sku != 'DCPHW' && this.sku != 'DCPHN' && this.sku != 'DCPNW') {
                        actualDeliveryService = actualDeliveryService + 1;
                    }
                } else if (this.product_type == 'Nordmann Fir' || this.product_type == 'Norway Spruce' || this.product_type == 'Pot Grown Fraser Fir' || this.product_type == 'Fraser Fir' || this.product_type == 'Noble Fir Christmas Trees' || this.product_type == 'Value Range Christmas Trees') {
                    trees = parseInt(this.quantity) + 1;
                }

                if (this.product_type != 'Delivery Services' && this.product_type != 'Collection Services') {
                    productsInCart = productsInCart + 1;
                }
            });

            //atleast 1 service should be selected
            if (services == 0) {
                if (window.innerWidth <= 991) {
                    $('.checkout-steps-2').addClass('active');
                } else {
                    $('.checkout-steps-1, checkout-steps-2').addClass('active');
                }

                $('.checkout-steps-3').removeClass('active');
                $('body').removeClass('final-step');
                $('#cartMsgDivNew').css('display', 'block');
                $('#cartMsgDivNew').addClass('cartMsgDivNew');
                $('#cartMsgDivNew').html('Please select Delivery/Installation service');
                $("html, body").animate({
                    scrollTop: $('#tblServices').offset().top
                }, "slow");

            } else {
                //alert('aa');
                //$('.edit_checkout').off('submit');
                //$('.edit_checkout')[0].submit();
                $('[data-trekkie-id="complete_order_button"]:visible').trigger('click', [true]);

            }

        }
    });

    return true;
};

var loader = '<img src="//www.pinesandneedles.com/cdn/shop/t/93/assets/ajax-loader.gif?v=97146236628943878521783230625">';

var couponList = [
  {
    code: 'freemini2019',
    id: 13328878370881
  },
  {
    code: 'festive19',
    id: 13328878370881
  },
  {
    code: 'moment20',
    id: 32181313208385
  },
  {
    code: 'wreath20',
    id: 12754531975233
  },
  {
    code: 'glam20',
    id: 32178300780609
  },
  {
    code: 'cosy',
    id: 40917548826818, //variant id
    minPrice: 8000 // Euro 80
  },
  {
    code: 'LIGHTMEUP',
    id: 12780085313601
  },
  /*{
    code: 'FREESWAG',
    id: 12754536104001,
    minPrice: 10000
  },*/
  {
    code: 'MINIGIFT',
    id: 13328878370881,
  },
  {
    code: 'MINILONDON',
    id: 13328878370881,
  },
  {
    code: 'LONDONGIFT',
    id: 13328878370881,
  },
  {
    code: 'HAPPY',
    id: 13328878370881,
  },
  {
    code: 'SMILE',
    id: 13328878370881,
  },
  {
    code: 'XMAS',
    id: 13328878370881,
  },
  {
    code: 'GIFT',
    id: 13328878370881,
  },
  {
    code: 'FESTIVE',
    id: 13328878370881,
  },
  {
    code: 'HOLLYHALO',
    id: 31064970199105, //variant id
    minPrice: 10000 // pound 100
  },
  {
    code: 'NOBLEHALO',
    id: 12754532106305, //variant id
    minPrice: 30000 // pound 300
  },
   {
    code: 'SERVING23',
    id: 43369117155522, //variant id
    minPrice: 10000 // pound 100
  },
  {
    code: 'EXTRABRIGHT',
    id: 12756622114881, //variant id
  }
];


var couponValidation = function(coupon, callback) {
  $.ajax({
    type: 'GET',
    url: '/apps/pines/shopify_discounts.php',
    dataType: "json",
    contentType: 'application/json',
    cache: false,
    data: {
      token:'32501192cc9a0918ea6a6df9bd48d6a5'
    },
    success: function(data) {
      // debugger;
      var hasCoupon = data.find(function(val) {
        return val.code.toLowerCase() === coupon.toLowerCase();
      });
      
      if(hasCoupon) {
        $('.couponError').text('');
      } else {
        $('.couponError').text('Enter a valid discount code');
      }
      
      callback && callback(hasCoupon ? '' : 'Enter a valid discount code');
    }
  });
  
};


var addCouponCallback = function(data, callback, couponVal) {
  //var val = ($('#couponCode').val()).trim();
  var coupon = couponVal ? couponVal : data.attributes.coupon;
  var items = data.items;
  var hasCouponPrd;
  var compleateCount = 0;
  //debugger;
  var cartData = function() {
    $.ajax({
      type: "GET",
      url: '/cart.json',
      cache: false,
      success: function(d) {
        callback && callback(d);
      }
    });
  };
  
  
  var applyCallback = function() {
    compleateCount++;
    
    if(items.length === compleateCount) {
      //console.log('applyCallback');
      var couponData = getPrdUsingCoupon(coupon);
      if(hasCouponPrd) {
        cartData();

      } else if(coupon && couponData) {
        if(couponData.minPrice) {
          if(data.total_price >= couponData.minPrice) {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: 1,
                id: couponData.id
              },
              dataType: 'json',
              success: function() {
                cartData();
              }
            });
          } else {
            cartData();
          }
        } else {
          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: 1,
                id: couponData.id
              },
              dataType: 'json',
              success: function() {
                cartData();
              }
            });
        }
        
      } else {
        cartData();

      }
    }
  };
  
  var applyLoop = function() {
    $.each(items, function(i, item) {
      var isCouponPrd = isCouponProduct(item.variant_id);

      if(isCouponPrd && isCouponPrd.code === coupon) {
        hasCouponPrd = true;
        applyCallback();

      } else if(isCouponPrd && isCouponPrd.code !== coupon) {
        $.ajax({
          type: "POST",
          url: '/cart/update.js?updates[' + item.variant_id + ']=0',
          cache: false,
          complete: function(data) {
            applyCallback();
          }
        });

      } else {
        applyCallback();

      }
    });
  };
  
  if(coupon) {
    addEditCartAttr('coupon', coupon, function() {
      $.ajax({
        url: '/discount/' + coupon,
        cache: false,
        dataType: 'json',
        complete: function(jqxhr, text) {
          applyLoop();
        }
      });
    });
    
  } else {
    addEditCartAttr('coupon', false, function() {
      applyLoop();
    });
  }
  
  
  
  
};

var addCouponNew = async (coupon, callback)=> {
  let [freeProduct, cart] = await addFreeProduct(coupon);
  $.ajax({//https://www.pinesandneedles.com/?_ab=0&_fd=0&_sc=1&preview_theme_id=136146387138
      url: 'https://www.pinesandneedles.com/discount/' + coupon+'/',
      cache: false,
      complete: function(jqxhr, text) {
              callback();
      }
  });
};

var addCoupon = function(data, callback, coupon) {
  if(data) {
    addCouponCallback(data, callback, coupon);
    
  } else {
    $.ajax({
      type: "GET",
      url: '/cart.json',
      cache: false,
      success: function(d) {
        addCouponCallback(d, callback, coupon);
      }
    });
    
  }
};


var getPrdUsingCoupon = function(coupon) {
  return couponList.find(function(val) {
    return val.code.toLowerCase() === (coupon ? coupon.toLowerCase() : coupon);
  });
};

var isCouponProduct = function(id) {
  return couponList.find(function(val) {
    return val.id === id;
  });
};

var removeCoupon = function(callback) {
  $('#cartLoading, #cartLoading2').html(loader);
  document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  
  addEditCartAttr('coupon', false, function() {
    $.ajax({
      url: '/checkout/?discount=+',
      cache: false,
      dataType: 'json',
      complete: function(jqxhr, text) {
        console.log('aa');
        renderCart();
        callback && callback();
      }
    });
  });
};


var checkCoupon = function(callback) {
  var val = ($('#couponCode').val()).trim();
  var coupon = val ? val : (locationSearch().discount ? locationSearch().discount : getCookie('discount_code'));
  
  if(coupon) {
    couponValidation(coupon, function(message) {
      if(message) {
        addEditCartAttr('coupon', false, callback, message);
        
      } else {
        addEditCartAttr('coupon', coupon, callback, message);
        
      }
    });
    
  } else {
    callback && callback('coupon', coupon, '');
  }
  
};

var addEditCartAttr = function(attr, val, callback, message) {
  var url = val ? ('[' + attr + ']=' + val) : ('[' + attr + ']=');
  
  $.ajax({
    type: "GET",
    url: '/cart/update.js?attributes' + url,
    cache: false,
    complete: function() {
      callback && callback(attr, val, message);
    }
  });
};

var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.244.253-.412.554-.5.874L.74 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425c.46-.27 1.01-.345 1.527-.205l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>';
var svg2 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 22"><path d="M15.286 2.386l7.91 13.857C25.01 19.423 23.65 22 20.16 22H3.84C.35 22-1.01 19.427.805 16.243l7.91-13.857c1.815-3.178 4.754-3.185 6.57 0zm-1.737.992c-1.05-1.838-2.05-1.837-3.1 0L2.54 17.235C1.468 19.122 1.93 20 3.84 20h16.32c1.91 0 2.374-.88 1.298-2.765l-7.91-13.857zM12 6.5c.552 0 1 .448 1 1V12c0 .552-.448 1-1 1s-1-.448-1-1V7.5c0-.552.448-1 1-1zm-1.5 10c0-.828.666-1.5 1.5-1.5.828 0 1.5.666 1.5 1.5 0 .828-.666 1.5-1.5 1.5-.828 0-1.5-.666-1.5-1.5z"></path></svg>';
var svg3 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15.1 2.3L13.7.9 8 6.6 2.3.9.9 2.3 6.6 8 .9 13.7l1.4 1.4L8 9.4l5.7 5.7 1.4-1.4L9.4 8"></path></svg>';

var couponHtml = async function() {
  $('#cartLoading, #cartLoading2').html(loader);
  
  $.ajax({
    type: "GET",
    url: '/cart.json',
    cache: false,
    success: async function(d) {
      //debugger;addItem
      
      let discount_applications = d.cart_level_discount_applications || [];
      let discount_coupon;
      if(discount_applications.length) {
        discount_coupon = discount_applications.find(item=> item.type === "discount_code");
      }
      else {
        discount_coupon = d.items.find((item) => (item.line_level_discount_allocations && item.line_level_discount_allocations.length));
        if(discount_coupon) {
          discount_coupon = discount_coupon.line_level_discount_allocations.find(item=> item.discount_application);
          if(discount_coupon) {
            discount_coupon = discount_coupon.discount_application;
          }
        }
      }
      
      if(discount_coupon) {
        
        let oldPrice = (d.original_total_price / 100);
        let finalPrice = d.total_price / 100;
        let restPrice = (oldPrice - finalPrice);
        let html = '<table>' +
        '<tbody>' +
        '<tr>' +
        '<td class="subTotalText">Subtotal <br>Discount ' + svg + discount_coupon.title + '</td>' +
        '<td width="90px" class="subTotalVal">£' + oldPrice.toFixed(2) + ' <br>- £' + restPrice.toFixed(2) + '</td>' +
        '</tr>' +
        '<tr>' +
        '<td class="totalText">Total</td>' +
        '<td class="totalVal">£' + finalPrice.toFixed(2) + '</td>' +
        '</tr>' +
        '</tbody>' +
        '</table>';

        $('.couponCodeDetails').html(html);
      }
      else {
        $('.couponCodeDetails').html("");
      }

      $('#cartLoading, #cartLoading2').html('');
      
      /*if(d.attributes.coupon) {
        var html = '';
      
        var note = $(this).find('.notice__text').html();
        
        //debugger;

        if(!finalPrice) {
          //debugger;
          //location.reload();
          //window.location = '/cart?review=true';
        }
        
        if(note) {
          $('.couponError').html('<div class="noticeText">' + svg2 + note + '<a class="removeCoupon">' + svg3 + '</a>' + '</div>');
          $('.couponCodeDetails').html('');
          $('#cartLoading, #cartLoading2').html('');
          
          $('.freeText').each(function() {
            $(this).html($(this).attr('data-price'));
          });
          
        } else {
          $('.couponError').html('');
          
        }
        
        html = note ? '' : '<div class="couponCodeSpan"><a class="removeCoupon">x</a>' + svg + d.attributes.coupon + '</div>';

        html += '<table>' +
          '<tbody>' +
          '<tr>' +
          '<td class="subTotalText">Subtotal <br>Discount ' + svg + d.attributes.coupon + '</td>' +
          '<td width="90px" class="subTotalVal">£' + oldPrice.toFixed(2) + ' <br>- £' + restPrice.toFixed(2) + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td class="totalText">Total</td>' +
          '<td class="totalVal">£' + finalPrice + '</td>' +
          '</tr>' +
          '</tbody>' +
          '</table>';

        $('.couponCodeDetails').html(html);
        $('#cartLoading, #cartLoading2').html('');
        
      } else {
        $('.couponError').html('');
        $('.couponCodeDetails').html('');
        $('#cartLoading, #cartLoading2').html('');
        
      }
      */
    }
  });
};

var locationSearch = function() {
  var search = location.search.substring(1);
  return search ? JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}') : {};
};
var findInArray = function(arr, key, val) {
  var toReturn;
  $.each(arr, function(z, val) {
    if(val[key] === val) {
      toReturn = val;
    }
  });
  
  return toReturn;
};

var getElementFromStringCallback = function(key, attr, val, callback) {
  callback(key, key.replace(/(<([^>]+)>)/ig, ''));
  
  getElementFromString(key.replace(/(<([^>]+)>)/i, ''), attr, val, callback);
};
var getElementFromString = function(str, attr, val, callback) {
  var a = val ? (attr + '="' + val + '"') : attr;
  var newReg = new RegExp('<([^\\s]+).*?' + a + '.*?>(.+?)<\\/\\1>', 'ig');
  var match = str.match(newReg);
  
  console.log(match);
  
  if(match && callback) {
    for(var l=0; l<match.length; l++) {
      getElementFromStringCallback(match[l], attr, val, callback);
      
      //var key = match[l].replace(/\s\s+/g, ' ');
      //var val = match[l].replace(/(<([^>]+)>)/ig, '');
      //var secondMatch = key.match(/<\/?[\w\s="/.':;#-\/\?]+>/gi);
      //var applyArray = [], newStr;
      
      //callback(key, val);
      
      //getElementFromString(key.replace(/(<([^>]+)>)/i, ''), attr, val, callback);
      
      /*if(secondMatch) {
        applyArray = secondMatch.slice(1, -1);
        newStr = applyArray.join('');
        console.log(applyArray);
        
        if(newStr) {
          getElementFromString(newStr, attr, val, callback);
        }
      }*/
      
    }
  }
  
  return match;
};

var validCartCallback = function(data, callback) {
  var items = data.items;
  var services = 0;
  var collectionServices = 0;
  var actualDeliveryService = 0;
  var trees = 0;
  var productsInCart = 0;
  var url = window.location.href;
  var isCartPage = url.indexOf('cart') !== -1 ? true : false;

  $.each(items, function(i, item) {
    if (item.product_type === 'Delivery Services') {
      services++;

      // Check whether it is actual delivery service means no tree delivery sevice
      if (item.sku !== 'DCPHW' && item.sku !== 'DCPHN' && item.sku !== 'DCPNW') {
        actualDeliveryService++;
      }

    } else if (item.product_type === 'Nordmann Fir' || item.product_type === 'Norway Spruce' || item.product_type === 'Pot Grown Fraser Fir' || item.product_type === 'Fraser Fir' || item.product_type === 'Noble Fir Christmas Trees' || item.product_type == 'Value Range Christmas Trees') {
      trees = trees + item.quantity;

    } else if (item.product_type === 'Collection Services') {
      collectionServices++;

    }

    if (item.product_type !== 'Delivery Services' && item.product_type !== 'Collection Services') {
      productsInCart++;

    }
  });

  var isValid = hideMessage();

  if (services == 0) {
    isValid = showMessage('Please select Delivery/Installation service');

  } else if (services > 1) {
    isValid = showMessage('You have multiple delivery services in cart. Please remove and keep one');

  } else if (collectionServices > 1) {
    isValid = showMessage('You have multiple collection services in cart. Please remove and keep one');

  } else if (trees > 5) {
    isValid = showMessage('Sorry but you can\'t have more than 5 trees in cart');

  } else if (trees == 0 && actualDeliveryService > 0) {
    isValid = showMessage('You have not selected tree for delivery service');

  } else if (trees > 0 && actualDeliveryService == 0) {
    isValid = showMessage('Please select valid delivery service for tree(s)');

  } else if (services > 0 && productsInCart == 0) {
    isValid = showMessage('You don\'t have any product in cart to deliver.');

  }

  callback && callback(isValid, isCartPage);
};

var validCart = function(callback, data) {
  if(data) {
    validCartCallback(data, callback);
    
  } else {
    $.ajax({
      type: "GET",
      url: '/cart.json',
      cache: false,
      success: function(d) {
        validCartCallback(d, callback);
      }
    });
    
  }
};

var showMessage = function(message) {
  $('#cartMsgDivNew').css('display', 'block');
  $('#cartMsgDivNew').addClass('cartMsgDivNew');
  $('#cartMsgDivNew').html(message);
  $('body').addClass('cartMsgDivShow');
  
  return false;
};

var hideMessage = function() {
  $('#cartMsgDivNew').css('display', 'none');
  $('#cartMsgDivNew').removeClass('cartMsgDivNew');
  $('body').removeClass('cartMsgDivShow');
  
  return true;
};

if (!String.prototype.includes) {
    String.prototype.includes = function(str) {
        var returnValue = false;

        if (this.indexOf(str) !== -1) {
            returnValue = true;
        }

        return returnValue;
    };
}

var getCookie = function(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
}

function showDescountText(){
  setTimeout(function(){
    var showtext = false; 
    $('.delivery-installation-row .left-name').each(function(){
      var dlv_text = $(this).text();
      if(dlv_text.indexOf('Nationwide') != -1){
        showtext = true; 
      }  
    });

    if(showtext == true){
      $('.discount-txt').show();
    }else{
      $('.discount-txt').hide();
    }
  }, 3000);
  
}

/*getElementFromString('<td class="product__price"><span class="order-summary__emphasis">£119.85</span></td>My name is <p class="aa"    >Bob</p>, Im <b class>20</b> years old, I like <b>programming</b>.', 'class', false, function(a, b) {
  console.log(a);
  console.log(b);
});*/

/*function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
  
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
  
    return 'false';
}

function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

var windowUrl = window.location.hash;

if(windowUrl === '#cartPreview') {
  setCookie('cartPreview', 'cartPreview', 1);
  
} else if(windowUrl === '#cartPreview:false') {
  eraseCookie('cartPreview');
  
}*/

var findQuantityById = function(items, id) {
  var quantity = 0;
  
  $.each(items, function(i) {
    if(this.id == id) {
      quantity = this.quantity;
    }
  });
  
  return quantity;
};

var updateCartloop = function(str, items, callback) {
  var arr = str.split(',');
  var _url = '';
  
  for(var i=0; i<arr.length; i++) {
    if(arr[i].trim()) {
      var _this = arr[i].toLowerCase().split(':');
      var _key = _this[0].trim();
      var _id = _this[1].trim();
      var _quantity = (_this[2] && parseInt(_this[2])) ? parseInt(_this[2]) : 1;

      _url += _url ? '&' : '';

      if(_key === 'add') {
        _quantity += findQuantityById(items, _id);
        _url += 'updates[' + _id + ']=' + _quantity;

      } else if(_key === 'update') {
        _url += 'updates[' + _id + ']=' + _quantity;

      } else if(_key === 'remove') {
        _url += 'updates[' + _id + ']=0';

      } else if(_key === 'attr') {
        _url += 'attributes[' + _id + ']=' + (_this[2] ? _this[2].trim() : '');

      }
    }
  }
  
  $.ajax({
    type: "POST",
    dataType: "json",
    url: '/cart/update.js?' + _url,
    cache: false,
    success: function(data) {
      callback && callback(data);
    }
  });
};

var updateCart = function(str, callback, data) {
  if(!str || str.trim().length == 0) {
    return;
  }
  
  if(data) {
    updateCartloop(str, data.items, callback);
  } else {
    $.ajax({
      type: "GET",
      url: '/cart.json',
      cache: false,  
      success: function(data) {
        updateCartloop(str, data.items, callback);
      }
    });
  }
};

function takeOnlyOnePrdStr(arr, count) {
  var _url = '';
  
  for(var i=0; i<arr.length; i++) {
    if(_url) {
      _url += ',remove:' + arr[i].id;
    } else {
      _url += 'update:' + arr[i].id + ':' + (count ? count : 1);
    }
  }

  return _url;
}

function getTotalCount(arr) {
  var total = 0;
  
  for(var i=0; i<arr.length; i++) {
    total += arr[i].quantity;
  }
  
  return total;
}



function verifyDeliveryDateTimeslot2(callback, oldData, ele) {
  var afterdata = function (data) {
    var deliveryServices = [];
    var extraDeliveryServices = [];
    var collectionServices = [];
    var extraCollectionServices = [];
    var timeSlot = [];
    var totalSucess = 0;
    var tree = [];
    var update = '';
    var actualDeliveryService = 0;
    
    $.each(data.items, function(i) {
      if(this.product_type == 'Delivery Services' || this.product_type == 'Collection Services') {

        if(this.product_type == 'Delivery Services') {
          deliveryServices.push(this);
          if (this.sku != 'DCPHW' && this.sku != 'DCPHN' && this.sku != 'DCPNW') {
            actualDeliveryService = actualDeliveryService + 1;
          }

        } else if(this.product_type == 'Collection Services') {
          collectionServices.push(this);

        }

        var time = {
          productType: this.product_type,
          serviceCode: this.sku,
          cartDate: '',
          cartSlot: ''
        };

        if($.isArray(this.properties)) {
          $.each(this.properties, function(k, j) {
            var name = j.name;
            var nameVal = j.value;

            if(name.includes("Date") !== false) {
              time.cartDate = nameVal;

            } else if(name.includes("Timeslot") !== false) {
              time.cartSlot = nameVal;

            }
          });
        } else {
          $.each(this.properties, function(k, j) {
            if(k.includes("Date") !== false) {
              time.cartDate = j;

            } else if(k.includes("Timeslot") !== false) {
              time.cartSlot = j;

            }
          });
        }

        timeSlot.push(time);
        
      } else if (this.product_type === 'Extra Delivery Services') {
        extraDeliveryServices.push(this);
        
      } else if (this.product_type === 'Extra Collection Services') {
        extraCollectionServices.push(this);
        
      } else if (this.product_type === 'Nordmann Fir' || this.product_type === 'Norway Spruce' || this.product_type === 'Pot Grown Fraser Fir' || this.product_type === 'Fraser Fir' || this.product_type === 'Noble Fir Christmas Trees' || this.product_type == 'Value Range Christmas Trees') {
        tree.push(this);
        
      }
    });
    
    if(getTotalCount(tree) === 0 && actualDeliveryService != 0) {
      $.ajax({
        type: "POST",
        dataType: 'json',
        url: '/cart/clear.js',
        success: function(){
          window.location.reload();
        }
      });
      return false;
      
    } else if(getTotalCount(tree) > 5) {
      callback && callback('Sorry but you can\'t have more than 5 trees in cart');
      return false;
      
    } else if(getTotalCount(deliveryServices) === 0) {
      callback && callback('Please select Delivery/Installation service');
      return false;
      
    }
    
    if(getTotalCount(deliveryServices) > 1 || getTotalCount(collectionServices) > 1) {
      update += (update ? ',' : '') + takeOnlyOnePrdStr(deliveryServices) + ',' + takeOnlyOnePrdStr(collectionServices);
    }
    
    if(getTotalCount(tree) !== (getTotalCount(extraDeliveryServices) + 1)) {
      update += (update ? ',' : '') + takeOnlyOnePrdStr(extraDeliveryServices, (getTotalCount(tree) - 1));
    }
    
    if(getTotalCount(collectionServices) && getTotalCount(tree) !== (getTotalCount(extraCollectionServices) + 1)) {
      update += (update ? ',' : '') + takeOnlyOnePrdStr(extraCollectionServices, (getTotalCount(tree) - 1));
    }
    
    if(update) {
      updateCart(update, function(d) {
        verifyDeliveryDateTimeslot2(callback, d, ele);
      }, data);
      return false;
    }
    
    var email = $('#checkout_email').val();
    var emailText = $('.step bdo').text();
    var finalEmail = email ? email : (emailText ? emailText : '');
    var finalText = finalEmail ? (finalEmail + '|' + $(ele).text()) : '';
    
    $.each(timeSlot, function(i) {
      if(this.cartDate && this.cartSlot) {
        $.ajax({
          type: "GET",
          url: '/apps/pines/verifyDeliveryDetails.php?serviceCode=' + this.serviceCode + '&cartDate=' + this.cartDate + '&cartSlot=' + this.cartSlot + '&productType=' + this.productType + '&email=' + finalText,
          dataType: "json",
          cache: false,	
          success: function(d) {
            if(d.status != 'Success') {
              callback && callback(d.content);

            } else {
              totalSucess++;

              if(totalSucess === timeSlot.length) {
                callback && callback();
              }
            }
          }
        });
      } else {
        callback && callback('Please select delivery date / time');
      }
    });
  };
  
  if(oldData) {
    afterdata(oldData);
  } else {
    $.ajax({
      type: "GET",
      url: '/cart.json',
      cache: false,  
      success: function(data) {
		afterdata(data);
      }
    });
  }
}
